import React, { useState, useEffect, useRef } from "react";
import {
  findVariantByBarcode,
  isDuplicateLine,
  lookupVariantBarcode,
  searchVariants,
  setLineVariant,
  variantBarcodeCouldGrow,
  variantOfDetail,
  withVariant,
} from "../variants";
import { calcBillTotals } from "../../../core/utils/salesTotals";
import {
  lineDiscountInput,
  writeLineDiscount,
  discPctEvents,
  discAmtRules,
  savedDiscountMode,
  anyLineTaxed,
} from "../../../core/utils/lineDiscount";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  ArrowLeft,
  Sun,
  Moon,
  Maximize,
  Minimize,
  MapPin,
  Plus,
  ChevronDown,
  ChevronRight,
  Sliders,
  RotateCcw,
  FileText,
  Trash2,
  Printer,
  Check,
} from "feather-icons-react/build/IconComponents";
import {
  getTaxList,
  getUnitList,
  getCustomersList,
  getDiscountList,
  getWareHouseList,
} from "../../../services/MasterApiServices";
import { getProductList } from "../../../services/MasterApiServices";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelector } from "react-redux";
import { InvSales } from "../../../core/json/invSales";
import { InvSalesDetail } from "../../../core/json/invSalesDetail";
import { useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchTax,
  fetchCategory,
  fetchCustomer,
  fetchSettings,
} from "../../../redux/userSetting";
import {
  addEditSales,
  getSalesByTransType,
} from "../../../services/SalesApiServices";
import { fetchBranchSettings } from "../../../redux/settingbyBranch";
import { fetchUserByBranch } from "../../../redux/userServices";
import { FinancialYear } from "../../../core/json/FinancialYear";

import { ProductClass } from "../../../core/json/Product";
import { DiscountClass } from "../../../core/json/Discount";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { TaxClass } from "../../../core/json/TaxClass";
import toast from "react-hot-toast";
import CustomerModal from "../../master/modal/CustomerModal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../../../style/fonts/Amiri";
import "../../../style/css/sales-invoice-terminal.css";
import {
  useTender,
  applyTender,
  TermTender,
  TermRoundOff,
  PAYMENT_TYPES,
} from "../terminal/Tender";
import html2pdf from "html2pdf.js";

import "jspdf-autotable";
import QRCode from "qrcode";
import { Buffer } from "buffer";
import arabic from "arabic-persian-reshaper";
import {getPrintSettingsByBranch} from '../../../services/AdminApiServices';
import { zatcaPrintQr, zatcaTimestamp } from "../../../core/utils/zatcaQr";
import { hasBarcode, barcodeIncludes, barcodeCouldGrow } from "../../../core/utils/productBarcode";
import SalesLastRates from "./SalesLastRates";
const ar = (text) => arabic(text);

const SalesInvoiceModal = ({
  mode,
  data,
  handleClose,
  handleRefresh,
  // modalOpen,
}) => {
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    watch,
    control,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: {
      deliveryDate: dayjs().format("YYYY-MM-DD"),
      invdate: dayjs().format("YYYY-MM-DD"),
      paymentType: 0,
      referencetype: 0,
      salesMode: 0,
      addition: 0,
      change: 0,
      customerContactno: "",
      customerName: "",
      refNo: "0",
      subtraction: 0,
      round: 0,
    },
    mode: "onBlur",
  });

  
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const handleAddRow = () => {
    append({
      batch: "0",
      code: "0",
      discountAmount: "0.0",
      discountPercentage: "0.0",
      expiry: dayjs().format("YYYY-MM-DD"),
      foc: "0.0",
      gross: "0.0",
      // hsnCode: 0,
      mrp: "0.0",
      netTotal: "0.0",
      price: "0.0",
      quantity: "0",
      taxAmount: "0.0",
      taxPercentage: "0.0",
      notes: "",
      unit: "",
      product: null,
    });
  };

  // ---- Terminal preferences ------------------------------------------------
  // All of these are per workstation and live in localStorage until the backend
  // exposes a settings endpoint - swap readPref / writePref for that call and
  // nothing else has to change.
  const COL_PREF_KEY = "salesInvoice.optionalColumns";
  const PRINT_PREF_KEY = "salesInvoice.printSettings";
  const FLOW_PREF_KEY = "salesInvoice.entryFlow";
  const THEME_PREF_KEY = "salesInvoice.theme";
  const STRIP_PREF_KEY = "salesInvoice.partyStrip";

  const readPref = (key, fallback) => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? { ...fallback, ...JSON.parse(raw) } : fallback;
    } catch {
      return fallback;
    }
  };
  const writePref = (key, value) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* storage unavailable - the choice just will not persist */
    }
  };

  // Optional grid columns. Batch / Expiry / MRP / FOC move into the line's
  // detail row when their column is off, so they stay editable either way.
  // Gross and Tax only ever hide: their inputs stay mounted because the print
  // builder reads them straight out of the DOM.
  const OPTIONAL_COLS = [
    { key: "batch", label: "Batch" },
    { key: "expiry", label: "Expiry" },
    { key: "mrp", label: "MRP" },
    { key: "foc", label: "FOC" },
    { key: "gross", label: "Gross" },
    { key: "tax", label: "Tax" },
  ];
  const [optionalCols, setOptionalCols] = useState(() =>
    readPref(COL_PREF_KEY, {
      batch: false,
      expiry: false,
      mrp: false,
      foc: false,
      gross: false,
      tax: true,
    })
  );
  const hideClass = (key) => (optionalCols[key] ? "" : "si-col-off");
  const toggleCol = (key) =>
    setOptionalCols((prev) => {
      const next = { ...prev, [key]: !prev[key] };
      writePref(COL_PREF_KEY, next);
      return next;
    });

  // ---- Print setup ----------------------------------------------------------
  // `printSettings` is already taken by the branch print config from the API,
  // so the operator's own preferences are `printPrefs`.
  const PRINT_FORMATS = [
    { key: "A4", label: "A4", size: "210 × 297 mm" },
    { key: "Thermal", label: "3 inch", size: "80 mm roll" },
  ];
  const [printPrefs, setPrintPrefs] = useState(() => {
    const saved = readPref(PRINT_PREF_KEY, {
      format: "A4",
      printers: { A4: "", Thermal: "" },
      remember: true,
    });
    const printers = { A4: "", Thermal: "", ...(saved.printers || {}) };
    // earlier saves held one printerName for whichever format was the default
    if (saved.printerName && !printers[saved.format]) {
      printers[saved.format] = saved.printerName;
    }
    return {
      format: saved.format === "Thermal" ? "Thermal" : "A4",
      printers,
      remember: saved.remember !== false,
    };
  });
  // null when shut, "setup" from the status bar, "confirm" when SAVE & PRINT
  // needs a format chosen first because "don't ask again" is off
  const [printPop, setPrintPop] = useState(null);
  const formatLabel = (key) =>
    PRINT_FORMATS.find((f) => f.key === key)?.label || key;
  const printTarget = `${formatLabel(printPrefs.format)}${
    printPrefs.printers[printPrefs.format]
      ? ` · ${printPrefs.printers[printPrefs.format]}`
      : " · system default"
  }`;
  const savePrintDefault = () => {
    writePref(PRINT_PREF_KEY, printPrefs);
    setPrintPop(null);
    toast.success(`Print setup saved - ${printTarget}`);
  };

  // ---- Save / Save & print ----------------------------------------------------
  // A ref rather than state, so the flag is already set when the submit handler
  // reads it - no dependence on a re-render landing between click and submit.
  const printOnSaveRef = useRef(false);
  const formRef = useRef(null);
  const submitInvoice = (withPrint) => {
    printOnSaveRef.current = withPrint;
    const form = formRef.current;
    if (!form) return;
    if (typeof form.requestSubmit === "function") form.requestSubmit();
    else
      form.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true })
      );
  };
  const saveAndPrint = () => {
    if (!printPrefs.remember) {
      setPrintPop("confirm");
      return;
    }
    submitInvoice(true);
  };

  // ---- Theme / full screen / party strip ---------------------------------
  const [siTheme, setSiTheme] = useState(
    () => readPref(THEME_PREF_KEY, { mode: "light" }).mode
  );
  const toggleTheme = () =>
    setSiTheme((prev) => {
      const next = prev === "dark" ? "light" : "dark";
      writePref(THEME_PREF_KEY, { mode: next });
      return next;
    });

  const [isFullScreen, setIsFullScreen] = useState(
    () => typeof document !== "undefined" && !!document.fullscreenElement
  );
  useEffect(() => {
    const sync = () => setIsFullScreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", sync);
    return () => document.removeEventListener("fullscreenchange", sync);
  }, []);
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      const req = document.documentElement.requestFullscreen?.();
      if (req?.catch)
        req.catch(() => toast.error("Full screen was blocked - press F11"));
    } else {
      document.exitFullscreen?.();
    }
  };

  const [moreOpen, setMoreOpen] = useState(
    () => readPref(STRIP_PREF_KEY, { more: false }).more
  );
  const toggleMore = () =>
    setMoreOpen((prev) => {
      writePref(STRIP_PREF_KEY, { more: !prev });
      return !prev;
    });

  // Line detail rows (batch / expiry / MRP / FOC when their column is off,
  // the line note, and the product facts), keyed by field id.
  const [openRows, setOpenRows] = useState({});
  const toggleRow = (id, focusNote) => {
    setOpenRows((prev) => ({ ...prev, [id]: focusNote ? true : !prev[id] }));
    if (focusNote) {
      setTimeout(() => document.getElementById(`si-note-${id}`)?.focus(), 0);
    }
  };

  // ---- Item entry flow ------------------------------------------------------
  //   direct   : picking an item adds it straight to the grid with qty 1
  //   qty      : picking moves to Qty, Enter adds the line at its list price
  //   qtyprice : Qty -> Enter -> Price -> Enter adds the line
  const [entryFlow, setEntryFlowState] = useState(
    () => readPref(FLOW_PREF_KEY, { mode: "qtyprice" }).mode
  );
  const [flowOpen, setFlowOpen] = useState(false);
  const [scanText, setScanText] = useState("");
  const [scanSel, setScanSel] = useState(0);
  const [pending, setPending] = useState(null);
  const [entryQty, setEntryQty] = useState("1");
  const [entryPrice, setEntryPrice] = useState("0");
  const [armed, setArmed] = useState(null); // "qty" | "price" | null
  const [lastAdded, setLastAdded] = useState(null);
  const scanRef = useRef(null);
  const qtyRef = useRef(null);
  const priceRef = useRef(null);

  const setEntryFlow = (mode) => {
    setEntryFlowState(mode);
    writePref(FLOW_PREF_KEY, { mode });
    setFlowOpen(false);
    resetEntry();
  };

  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens (light and dark) like everything else
  const [menuHost, setMenuHost] = useState(null);

  // An untouched row - no product, no quantity, no price.
  const isBlankRow = (row) =>
    !row?.product && !(Number(row?.quantity) > 0) && !(Number(row?.price) > 0);

  // The trailing blank row is only there to start the next entry: it is exempt
  // from validation and dropped before submit and before printing. A lone blank
  // row is not a placeholder - an invoice needs at least one real line.
  const isPlaceholderRow = (index) => {
    const rows = getValues("items") || [];
    return (
      rows.length > 1 && index === rows.length - 1 && isBlankRow(rows[index])
    );
  };

  // A blank row appears on its own once the last one has a product and a
  // quantity - so there is nothing to click to keep entering items.
  // NOTE: react-hook-form mutates its value store in place, so `watch("items")`
  // hands back the same array reference on every render. Depending on that
  // array directly would run this effect once and never again - the dependency
  // has to be a primitive built from the values we actually care about.
  const watchedItems = watch("items");
  const lastRow = watchedItems?.[watchedItems.length - 1];
  const lastRowKey = [
    watchedItems?.length ?? 0,
    lastRow?.product ?? "",
    lastRow?.quantity ?? "",
    lastRow?.price ?? "",
  ].join("|");

  useEffect(() => {
    const rows = getValues("items") || [];
    if (!rows.length) return;
    const last = rows[rows.length - 1];
    if (last?.product && Number(last?.quantity) > 0) handleAddRow();
  }, [lastRowKey]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchTax());
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
    dispatch(fetchCustomer(branch));
    dispatch(fetchUserByBranch(branch));
  }, []);

  const { customerList } = useSelector((state) => state.usersetting);
  
  const [discountList, setdiscountList] = useState([]);

  const [taxData, setTaxData] = useState([]);
  const [taxReady, setTaxReady] = useState(false);
  const [printSettings, setPrintSettings] = useState(null);

  const [unitData, setunitData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [salesData, setsalesData] = useState([]);
  const [discountData, setdiscountData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const [mindate, setmindate] = useState();
  // Get user from redux
  const { userId } = useSelector((state) => state.userauth);
  // Get branch from redux
  const { branch } = useSelector((state) => state.branchlist);

  const { productList, unitList, taxList, settingList } = useSelector(
    (state) => state.usersetting
  );
  const { branchsettings } = useSelector((state) => state.settings);
  const sizeColour = !!branchsettings?.enableSizeColour;
  const { UserListByBranch } = useSelector((state) => state.userservice);

  // Salesman is picked from the branch's users rather than typed free-hand.
  const salesmanOptions = (UserListByBranch || []).map((u) => ({
    label: u?.name,
    value: u?.guid,
  }));

  // Every picker renders its menu in a body-level portal. Previously the menus
  // used position:relative, which put them in the document flow - opening one
  // inside a row pushed the rest of that row out of line, and inside the
  // scrolling table body an absolute menu would simply have been clipped.
  const menuPortalTarget =
    menuHost || (typeof document !== "undefined" ? document.body : null);
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };
  const { companyInfolist } = useSelector((state) => state.companyInfo);

  // Column widths, set inline on each header cell. The item column carries no
  // width so it takes whatever the fixed columns leave; the table's min-width
  // tracks the columns actually showing, so below it the grid scrolls sideways
  // instead of crushing anything.
  // VAT shows when the branch charges tax, and also whenever a line on the
  // bill carries VAT - an amount that is charged is never hidden
  const taxOn =
    branchsettings?.disableTaxInSale == false ||
    anyLineTaxed(fields, watch, taxData);
  // The width each grid column needs to show its content - a money figure, a
  // date, the two row buttons. These are applied directly, and the table's
  // min-width is their sum for whatever is on screen: the columns share any
  // extra room proportionally, and only when even the minimums do not fit does
  // the grid scroll rather than crush a column.
  const COL_W = {
    idx: 34,
    item: 200,
    unit: 72,
    qty: 58,
    rate: 78,
    gross: 78,
    discPct: 56,
    discAmt: 78,
    taxPct: 56,
    taxAmt: 78,
    mrp: 76,
    foc: 56,
    batch: 76,
    expiry: 84,
    amount: 84,
    act: 72,
  };
  const visibleCols = [
    "idx",
    "item",
    "unit",
    "qty",
    "rate",
    ...(optionalCols.gross ? ["gross"] : []),
    "discPct",
    "discAmt",
    ...(taxOn && optionalCols.tax ? ["taxPct", "taxAmt"] : []),
    ...(optionalCols.mrp ? ["mrp"] : []),
    ...(optionalCols.foc ? ["foc"] : []),
    ...(optionalCols.batch ? ["batch"] : []),
    ...(optionalCols.expiry ? ["expiry"] : []),
    "amount",
    "act",
  ];
  const tableMinWidth = visibleCols.reduce((t, k) => t + COL_W[k], 0);
  const colW = (key) => COL_W[key];
  // const companyList = companyInfolist.map((company) => ({
  //   name: company.name,
  //   address1: company.address1,
  //   address2: company.address2,
  //   address3: company.address3,
  //   phone: company.phone
  // }));
useEffect(() => {
  const fetchPrintSettings = async () => {
    try {
      const response = await getPrintSettingsByBranch(branch?.guid);
      setPrintSettings(response);
    } catch (error) {
      console.error("Failed to fetch print settings", error);
    }
  };

  if (branch?.guid) {
    fetchPrintSettings();
  }
}, [branch]);


  // Online replaces UPI as the label; the stored value (2) is unchanged
  const paymentType = PAYMENT_TYPES;
  //   like reference type in purchase//transtype
  const referencetype = [
    { value: 0, label: "DIRECT" },
    { value: 1, label: "DN" },
    { value: 2, label: "ORDER" },
  ];

  const salesMode = [
    { value: 0, label: "NORMAL SERIES" },
    { value: 1, label: "QUOT SERIES" },
  ];
  useEffect(() => {}, [getValues, errors]);
  // const purchaseTransType = [
  //   { value: 0, label: "Sales Quotation" },
  //   { value: 1, label: "Delievery Note" },
  //   { value: 2, label: "Sales Invoice" },
  //   { value: 3, label: "Sales Return" },
  // ];

  const [warehouses, setWarehouses] = useState([]);
  
useEffect(() => {
  const fetchWarehouses = async () => {
    try {
      const response = await getWareHouseList(branch?.guid);

      if (Array.isArray(response)) {
        // Filter warehouses by current branch
        const filtered = response.filter(
          (wh) => wh.branchID === branch?.guid
        );
        setWarehouses(filtered);
      } else {
        setWarehouses([]);
      }
    } catch (err) {
      console.error("Failed to fetch warehouses:", err);
    }
  };
  if (branch?.guid) {
    fetchWarehouses();
  }
}, [branch]);
  
const formattedWarehouses = Array.isArray(warehouses)
  ? warehouses.map((warehouse) => ({
      label: warehouse.name || "Unnamed Warehouse",
      value: warehouse,
    }))
  : [];

// Helper function to get selected warehouse option
const getSelectedWarehouseOption = (warehouse) => {
  if (!warehouse) return null;
  return (
    formattedWarehouses.find((wh) => wh.value.guid === warehouse.guid) || {
      label: warehouse.name || "Select Warehouse",
      value: warehouse,
    }
  );
};
// Helper to get default warehouse from branch settings
const getDefaultWarehouse = () => {
  if (!branchsettings?.defaultWareHouseID || !warehouses?.length) return null;
  const wh = warehouses.find((w) => w.guid === branchsettings.defaultWareHouseID);
  return wh ? getSelectedWarehouseOption(wh) : null;
};


  //Calculations ---------------
  const safeNumber = (value, defaultValue = 0) => {
    // Check for null, undefined, or empty string and use the default value
    if (value === null || value === undefined || value === "") {
      return defaultValue;
    }

    // Convert to number
    const num = Number(value);

    // Return the number or the default value if num is NaN
    return isNaN(num) ? defaultValue : num;
  };
  const rowUseForm = getValues("row") || [];

  let totalGross = 0;
  let totalDiscount = 0;
  let totalTax = 0;
  let totalNet = 0;
  let changevalue = 0;

  // VAT the ZATCA way, the same on every screen, print and e-invoice
  // (core/utils/salesTotals.js): the bill discount (subtraction) and the
  // addition change the taxable amount, and VAT is worked out on what is left
  const addition = Number(watch(`addition`, 0));
  const subtraction = Number(watch(`subtraction`, 0));
  const round = Number(watch(`round`, 0));
  const billCalc = calcBillTotals(
    fields.map((field, index) => {
      const taxGUID = watch(`items[${index}].taxPercentage`, 0);
      return {
        quantity: watch(`items[${index}].quantity`, 0),
        price: watch(`items[${index}].price`, 0),
        ...lineDiscountInput(watch, index),
        taxPercent: taxData.find((t)=>t.guid==taxGUID)?.value || 0,
      };
    }),
    {
      billDiscount: safeNumber(subtraction),
      addition: safeNumber(addition),
      roundOff: safeNumber(round),
      decimals: Number(decimalpoints) >= 0 ? Number(decimalpoints) : 2,
    }
  );
  billCalc.lines.forEach((t, index) => {
    setValue(`items[${index}].gross`, t.gross.toFixed(decimalpoints));
    writeLineDiscount(getValues, setValue, index, t, decimalpoints);
    setValue(`items[${index}].taxAmount`, t.tax.toFixed(decimalpoints));
    setValue(`items[${index}].netTotal`, t.net.toFixed(decimalpoints));
  });
  totalGross = billCalc.gross;
  totalDiscount = billCalc.discountTotal;
  totalTax = billCalc.tax;
  totalNet = billCalc.net;
  const paidvalue = Number(watch(`paid`), 0);
  if (paidvalue !== 0) {
    // Change = Paid - Net Total. Signed on purpose: a short payment has to read
    // as negative rather than as change owed back, so no Math.abs here.
    changevalue = safeNumber(paidvalue) - totalNet;
    setValue("change", changevalue?.toFixed(decimalpoints));
  } else {
    setValue("change", 0);
  }
  //end-------------
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one product entry is required");
    }
  }
  const handleDiscountList = async () => {
    try {
      const response = await getDiscountList();

      const formattedDiscount = response?.map((discount) => ({
        label: discount.percentage,
        value: discount.percentage,
        guid: discount.guid,
      }));
      setdiscountData(formattedDiscount);
      setdiscountList(response);
    } catch (error) {
      console.error(
        "Error fetching discount",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };
  const handleUnitList = async () => {
    try {
      const response = await getUnitList();
      const formattedUnit = response?.map((unit) => ({
        label: unit.name,
        value: unit.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };


  

  const handleTaxList = async () => {
    try {
      const response = await getTaxList();

      const formattedTax = response?.map((tax) => ({
        label: tax.percentage,
        value: tax.percentage,
        guid: tax.guid,
      }));
      setTaxData(Array.isArray(formattedTax) ? formattedTax : []);
    } catch (error) {
      console.error(
        "Error fetching tax",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    } finally {
      // an edit loads once the tax list has been asked for, even when the
      // branch has no taxes - waiting for a non-empty list left it blank
      setTaxReady(true);
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setLineVariant(setValue, index, null);
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(
        `items[${index}].code`,
        `${productData?.barcode || productData?.code || ""}`
      );
      // setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].taxPercentage`, productData?.taxID || 0);
      setValue(`items[${index}].price`, productData?.retailRate || 0);

      // Picking an item means one of it unless the operator says otherwise, so
      // seed the quantity and drop the cursor straight into it - ready to type
      // over for any other number, or to scan the next barcode.
      const currentQty = Number(getValues(`items[${index}].quantity`));
      if (!currentQty) setValue(`items[${index}].quantity`, 1);
      setTimeout(() => {
        try {
          setFocus(`items[${index}].quantity`);
        } catch {
          /* row unmounted before the product resolved */
        }
      }, 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  // Barcode entry / scanner input. A scanner types the digits then sends Enter,
  // so the same handler serves both a scan and a typed-in code.
  const handleBarcodeEntry = (rawValue, index) => {
    const scanned = `${rawValue ?? ""}`.trim();
    if (!scanned) return;

    const match =
      (sizeColour && findVariantByBarcode(productList, scanned)) ||
      productList?.find(
        (p) =>
          hasBarcode(p, scanned) ||
          `${p?.code ?? ""}`.trim() === scanned
      );

    if (!match) {
      // put the row back to whatever product it already held
      const current = productList?.find(
        (p) => p.guid === getValues(`items[${index}].product`)
      );
      setValue(
        `items[${index}].code`,
        `${current?.barcode || current?.code || ""}`
      );
      toast.error(`No item found for barcode ${scanned}`);
      return;
    }

    // load it exactly the way picking from the name dropdown does
    Promise.resolve(handleEachProductfetch({ value: match.guid }, index)).then(() =>
      setLineVariant(setValue, index, match.__variant || null)
    );
  };

  // lets the item picker be searched by name, barcode or item code
  const productFilterOption = (option, rawInput) => {
    const input = `${rawInput ?? ""}`.trim().toLowerCase();
    if (!input) return true;
    const { label, barcodes, code } = option.data || {};
    return (
      `${label ?? ""}`.toLowerCase().includes(input) ||
      barcodeIncludes({ barcodes }, input) ||
      `${code ?? ""}`.toLowerCase().includes(input)
    );
  };

  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.filter(
        (product) => product.guid === guid
      );
      return filteredData[0];
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  }

  // ---- Scan bar -----------------------------------------------------------
  const productByGuid = (guid) =>
    guid ? productList?.find((p) => p.guid === guid) : undefined;
  const unitLabel = (guid) =>
    unitData?.find((u) => u.value === guid)?.label || "";

  const [scanOpen, setScanOpen] = useState(false);
  const scanQuery = scanText.trim().toLowerCase();
  const scanResults =
    !scanQuery || pending
      ? []
      : [
          ...(productList || []).filter(
            (p) =>
              `${p?.name ?? ""}`.toLowerCase().includes(scanQuery) ||
              `${p?.code ?? ""}`.toLowerCase().includes(scanQuery) ||
              barcodeIncludes(p, scanQuery)
          ),
          ...(sizeColour ? searchVariants(productList, scanQuery) : []),
        ].slice(0, sizeColour ? 12 : 8);

  // a variant barcode / SKU first, then the product's own barcode or code
  const exactProduct = (text) => {
    const t = `${text ?? ""}`.trim();
    if (!t) return null;
    return (
      (sizeColour && findVariantByBarcode(productList, t)) ||
      productList?.find(
        (p) => hasBarcode(p, t) || `${p?.code ?? ""}`.trim() === t
      ) ||
      null
    );
  };

  function resetEntry() {
    setPending(null);
    setScanText("");
    setScanSel(0);
    setEntryQty("1");
    setEntryPrice("0");
    setArmed(null);
    setTimeout(() => scanRef.current?.focus(), 0);
  }

  // Puts a product on the grid. A product already on the invoice gets its
  // quantity raised instead of a second line; otherwise the trailing blank line
  // is filled (one is appended when there is none) through the very same
  // handleEachProductfetch the in-row picker uses, so unit, tax and price load
  // exactly as they always have.
  async function addLine(product, qty, price) {
    const q = Number(qty) > 0 ? Number(qty) : 1;
    const rows = getValues("items") || [];
    const variant = product.__variant || null;
    // a variant with its own price: handleEachProductfetch sets the product's
    if (variant && price === undefined && safeNumber(product.retailRate) !== safeNumber(productByGuid(product.guid)?.retailRate))
      price = safeNumber(product.retailRate);
    const existing = rows.findIndex(
      (r) => r?.product === product.guid && (r?.variantID || null) === (variant?.variantID || null)
    );
    if (existing > -1) {
      setValue(
        `items[${existing}].quantity`,
        safeNumber(rows[existing].quantity) + q
      );
      if (price !== undefined) setValue(`items[${existing}].price`, price);
    } else {
      let index = rows.length - 1;
      if (index < 0 || !isBlankRow(rows[index])) {
        handleAddRow();
        index = rows.length;
      }
      await handleEachProductfetch({ value: product.guid }, index);
      setLineVariant(setValue, index, variant);
      setValue(`items[${index}].quantity`, q);
      if (price !== undefined) setValue(`items[${index}].price`, price);
    }
    setLastAdded({
      name: product.name,
      qty: q,
      unit: unitLabel(product.unit),
      price: price !== undefined ? price : safeNumber(product.retailRate),
    });
    // the row picker drops focus into Qty; the terminal wants it back on the
    // scanner, ready for the next item
    setTimeout(() => scanRef.current?.focus(), 40);
  }

  function beginEntry(product) {
    if (!product) return;
    setScanOpen(false);
    setScanSel(0);
    if (entryFlow === "direct") {
      addLine(product, 1);
      resetEntry();
      return;
    }
    setPending(product);
    setScanText(product.name || "");
    setEntryQty("1");
    setEntryPrice(`${safeNumber(product.retailRate)}`);
    setArmed("qty");
    setTimeout(() => {
      qtyRef.current?.focus();
      qtyRef.current?.select();
    }, 0);
  }

  function commitEntry() {
    if (!pending) return;
    const q = safeNumber(entryQty);
    const p = entryFlow === "qtyprice" ? safeNumber(entryPrice) : undefined;
    addLine(pending, q > 0 ? q : 1, p);
    resetEntry();
  }

  const onScanChange = (e) => {
    const v = e.target.value;
    setScanText(v);
    setScanSel(0);
    setScanOpen(true);
    if (pending) {
      setPending(null);
      setArmed(null);
    }
    // A scanner types the whole code and then Enter. A full-length barcode
    // that no longer barcode could still grow into is taken at once; anything
    // shorter waits for Enter, so a short item code can't fire on keystroke 1.
    const t = v.trim();
    if (t.length >= 8) {
      const hit =
        (sizeColour && findVariantByBarcode(productList, t)) ||
        productList?.find((p) => hasBarcode(p, t));
      const longer =
        productList?.some((p) => barcodeCouldGrow(p, t)) ||
        (sizeColour && variantBarcodeCouldGrow(productList, t));
      if (hit && !longer) beginEntry(hit);
    }
  };

  const onScanKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setScanOpen(true);
      setScanSel((s) => Math.min(s + 1, Math.max(scanResults.length - 1, 0)));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setScanSel((s) => Math.max(s - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (pending) {
        qtyRef.current?.focus();
        return;
      }
      const hit = exactProduct(scanText);
      const typed = scanText.trim();
      if (hit) beginEntry(hit);
      else if (scanResults[scanSel]) beginEntry(scanResults[scanSel]);
      else if (typed && sizeColour)
        // a barcode the product list doesn't know - ask the server
        lookupVariantBarcode(productList, typed).then((p) =>
          p ? beginEntry(p) : toast.error(`No item found for "${typed}"`)
        );
      else if (typed) toast.error(`No item found for "${typed}"`);
    } else if (e.key === "Escape") {
      e.preventDefault();
      resetEntry();
    }
  };

  const onEntryQtyKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (!pending) {
        scanRef.current?.focus();
        return;
      }
      if (entryFlow === "qtyprice") {
        setArmed("price");
        setTimeout(() => {
          priceRef.current?.focus();
          priceRef.current?.select();
        }, 0);
      } else commitEntry();
    } else if (e.key === "Escape") {
      e.preventDefault();
      resetEntry();
    }
  };

  const onEntryPriceKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      commitEntry();
    } else if (e.key === "Escape") {
      e.preventDefault();
      resetEntry();
    }
  };

  // ---- Figures for the rail, the lines footer and the status bar --------
  const liveRows = getValues("items") || [];
  const realRows = liveRows.filter((r) => r?.product);
  const lineCount = realRows.length;
  const qtyTotal = realRows.reduce((s, r) => s + safeNumber(r.quantity), 0);
  const hasCost = realRows.some(
    (r) => safeNumber(productByGuid(r.product)?.cost) > 0
  );
  const costTotal = realRows.reduce(
    (s, r) =>
      s + safeNumber(r.quantity) * safeNumber(productByGuid(r.product)?.cost),
    0
  );
  const billDiscount = safeNumber(subtraction);
  const lineDiscount = totalDiscount - billDiscount;
  const taxableTotal = totalGross - lineDiscount - billDiscount + safeNumber(addition); // the amount VAT is charged on
  const marginPct =
    hasCost && taxableTotal > 0
      ? ((taxableTotal - costTotal) / taxableTotal) * 100
      : null;
  const paidNow = safeNumber(watch("paid"));
  const balance = paidNow - totalNet;
  const balanceState =
    Math.abs(balance) < 0.005 ? "ok" : balance > 0 ? "change" : "due";
  const paymentLabel =
    paymentType.find((p) => p.value === watch("paymentType"))?.label || "Cash";
  const selectedCustomer = customerList?.find(
    (c) => c.guid === watch("customer")
  );
  const salesmanName = salesmanOptions.find(
    (o) => o.value === watch("salesman")
  )?.label;
  const warehouseName = watch("location")?.name;
  const currentUser = (UserListByBranch || []).find(
    (u) => u.guid === userId?.id
  );
  const userInitials = `${currentUser?.name || ""}`
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase())
    .join("");
  const docState =
    mode === "edit"
      ? { key: "edit", label: "Editing" }
      : lineCount
      ? { key: "unsaved", label: "Unsaved" }
      : { key: "new", label: "New" };
  const fmtN = (v) => safeNumber(v).toFixed(decimalpoints);

  // Cash / Card / Online / Credit lines, quick cash and the balance row
  const tender = useTender({
    screenKey: "salesInvoice",
    control,
    setValue,
    netTotal: totalNet,
    decimalpoints,
    paymentType: watch("paymentType"),
  });


  // ---- Keyboard ---------------------------------------------------------------
  // F2 customer, F3 scanner, F4 tender, F9 save & print. Re-bound every render
  // so the handlers always see current state; stands down while the customer
  // modal is on top.
  useEffect(() => {
    const onKey = (e) => {
      if (modalOpen) return;
      if (e.key === "F2") {
        e.preventDefault();
        try {
          setFocus("customer");
        } catch {
          /* picker not mounted */
        }
      } else if (e.key === "F3") {
        e.preventDefault();
        scanRef.current?.focus();
        scanRef.current?.select();
      } else if (e.key === "F4") {
        const el = document.querySelector(
          '.si-term [data-term-field="tender"]'
        );
        if (el) {
          e.preventDefault();
          el.focus();
          el.select?.();
        }
      } else if (e.key === "F9") {
        e.preventDefault();
        saveAndPrint();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  });

  // Enter must never submit the invoice by accident - the first submit button
  // in the form is SAVE & PRINT, so implicit submission would print. Inside an
  // item line Enter hands control back to the scanner; Ctrl+Delete removes it.
  const onFormKeyDown = (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    const inLine = t.closest(".si-table");
    if (e.key === "Delete" && e.ctrlKey && inLine) {
      const tr = t.closest("tr[data-line]");
      if (tr) {
        e.preventDefault();
        handleRemove(Number(tr.dataset.line));
        setTimeout(() => scanRef.current?.focus(), 0);
      }
      return;
    }
    if (e.key !== "Enter" || e.defaultPrevented) return;
    if (t.type === "checkbox" || t.type === "radio") return;
    e.preventDefault();
    if (inLine) {
      scanRef.current?.focus();
      scanRef.current?.select();
    }
  };

  const handleCustomerList = async () => {
    try {
      const formattedCustomers = customerList?.map((customer) => ({
        label: customer.name,
        value: customer.guid,
      }));
      setCustomerData(formattedCustomers);
    } catch (error) {
      console.error(
        "Error fetching customers",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  const handlesalesData = async () => {
    try {
      const response = await getSalesByTransType(branch, 2);
      setsalesData(response.data);
    } catch (error) {
      console.error("Failed to fetch sales invoices", error);
    }
  };
  const handlecustomerDetailFetch = async (selectedOption) => {
    try {
      const customerData = customerList?.find(
        (e) => e.guid == selectedOption.value
      );

      setValue("customerContactno", customerData?.mobile || 0);
      setValue("customerName", customerData?.name || "");
    } catch (error) {
      console.error("Error fetching product by GUID:", error);
    }
  };

  // Fetch sales invoices data
  const handleEntryNo = async () => {
    try {
      const response = await getSalesByTransType(branch, 2);
      const salesData = response.data;

      // Group entry numbers by prefix
      const entryGroups = (Array.isArray(salesData) ? salesData : []).reduce((groups, data) => {
        const entrynumber = `${data?.entrynumber ?? ""}`;
        // Extract the prefix (non-numeric characters). A number with no letter
        // prefix used to throw here, so no SI number was set and new invoices
        // could not be numbered - skip it instead.
        const prefix = entrynumber.match(/^[A-Za-z]+/)?.[0];
        if (!prefix) return groups;
        // Extract the numeric part and convert it to an integer
        const entryNum = parseInt(entrynumber.replace(/\D/g, ""), 10);
        if (!Number.isFinite(entryNum)) return groups;

        if (!groups[prefix]) {
          groups[prefix] = [];
        }
        groups[prefix].push(entryNum);

        return groups;
      }, {});

      // Get the desired prefix (e.g., "SQ")
      const prefix = "SI";
      const maxEntryNumber =
        entryGroups[prefix]?.length > 0 ? Math.max(...entryGroups[prefix]) : 0;

      // Increment the counter for the prefix
      const counter = maxEntryNumber + 1;

      // Set the new entry number with the updated counter
      setValue(`entrynumber`, `${prefix}${counter}`);
    } catch (error) {
      console.error(
        "Failed to fetch sales invoices",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

  // function resetmodal() {
  //   if (mode === "edit" && data) {
  //     setValue("terms", data.terms);
  //     setValue("entrynumber", data.entrynumber);
  //     setValue("salesMode", data.salesMode || 0);
  //     setValue("salesTransType", data.salesTransType || 2);
  //     setValue("paid", data.paid || 0);
  //     setValue("change", Number(data.change) || 0);
  //     setValue("refNo", data.refNo || 0);
  //     setValue("dispatch", data.dispatch || "");
  //     setValue("dispatchTrough", data.dispatchTrough || "");
  //     setValue("addition", data.additionalAmt || 0);
  //     setValue("subtraction", data.discAmt || 0);
  //     setValue("round", data.roundOff || 0);
  //     setValue("grossTotal", data.grossTotal || 0);
  //     setValue("discountTotal", data.discountTotal || 0);
  //     setValue("taxTotal", data.taxTotal || 0);
  //     setValue("netAmt", data.netAmt || 0);
  //     setValue("paymentType", data.salesPaymentType || 0);
  //     setValue("referencetype", data.reftype || 0);
  //     setValue("customer", data.customer.guid);
  //     setValue("customerContactno", data.customerContactno || "0");
  //     setValue("customerName", data.customerName || "");
  //     setValue("invdate", dayjs(data.invdate) || dayjs());
  //     setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());

  //     setValue(
  //       "items",
  //       data?.invSalesDetails?.map((detail, i) => {
  //         return {
  //           product: detail?.product?.guid,
  //           code: detail?.product?.code,
  //           // hsnCode: detail?.product?.hsnCode || 0,
  //           batch: detail.batch,
  //           expiry: dayjs(detail.expiryDate),
  //           unit: detail.unit?.guid,
  //           quantity: detail.quantity,
  //           price: detail.price,
  //           mrp: detail.mrp,
  //           foc: detail.foc,
  //           discountPercentage: detail.discPercentage,
  //           discountAmount: detail.discAmt,
  //           taxPercentage: detail.taxPercentage,
  //           gross: detail.gross,
  //           taxAmount: detail.taxamnt,
  //           netTotal: detail.netAmt,
  //         };
  //       })
  //     );
  //   }
  // }

  async function resetmodal() {
  if (mode === "edit" && data) {
    setValue("terms", data.terms);
    setValue("entrynumber", data.entrynumber);
    setValue("salesMode", data.salesMode || 0);
    setValue("salesTransType", data.salesTransType || 2);
    setValue("paid", data.paid || 0);
    setValue("change", Number(data.change) || 0);
    setValue("refNo", data.refNo || 0);
    setValue("dispatch", data.dispatch || "");
    setValue("dispatchTrough", data.dispatchTrough || "");
    setValue("addition", data.additionalAmt || 0);
    setValue("subtraction", data.discAmt || 0);
    setValue("round", data.roundOff || 0);
    setValue("grossTotal", data.grossTotal || 0);
    setValue("discountTotal", data.discountTotal || 0);
    setValue("taxTotal", data.taxTotal || 0);
    setValue("netAmt", data.netTotal || 0);
    setValue("paymentType", data.salesPaymentType || 0);
    setValue("referencetype", data.reftype || 0);
    // POS walk-in bills can come back with no customer; reading .guid off null
    // threw here and left the whole edit form empty. Fall back to the branch's
    // default customer, else leave the (required) picker for the operator.
    setValue(
      "customer",
      data.customer?.guid || branchsettings?.defaultCustomerID || undefined
    );
    setValue("customerContactno", data.customerContactno || "0");
    setValue("customerName", data.customerName || "");
    setValue("invdate", dayjs(data.invdate) || dayjs());
    setValue("deliveryDate", dayjs(data.deliveryDate) || dayjs());
   if (data.location?.guid) {
      const selectedWarehouse = getSelectedWarehouseOption(data.location);
      setValue("location", selectedWarehouse.value || data.location);
    }
    // Map items properly
    const items = (data.invSalesDetails || []).map((detail) => {
      const taxGuid =
        taxData.find((t) => Number(t.value) === Number(detail.taxPercentage))
          ?.guid || null;

      return {
        ...variantOfDetail(detail),
        product: detail?.product?.guid,
        code: detail?.product?.code,
        batch: detail.batch,
        expiry: dayjs(detail.expiryDate),
        unit: detail.unit?.guid,
        quantity: detail.quantity,
        price: detail.price,
        mrp: detail.mrp,
        foc: detail.foc,
        discountPercentage: detail.discPercentage,
        discountAmount: detail.discAmt,
        discountMode: savedDiscountMode(detail.discAmt),
        taxPercentage: taxGuid, // GUID of the tax
        gross: detail.gross,
        taxAmount: detail.taxamnt,
        netTotal: detail.netAmt,
        notes: detail.details || "",
      };
    });

    setValue("items", items);
  }
}

useEffect(() => {
  if (data && taxReady) {
    resetmodal();
  }
}, [data, taxData, taxReady]);


  // useEffect(() => {
  //   resetmodal();
  // }, [data, setValue]);

  useEffect(() => {
    handleCustomerList();
  }, [customerList]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (mode === "add") {
  //       handleEntryNo();
  //       if (!isRowAdded && fields?.length === 0) {
  //         handleAddRow();
  //         setIsRowAdded(true);
  //       }
  //     }
  //     handleProductsList();

  //     handleTaxList();
  //     handleUnitList();
  //     handlesalesData();
  //     handleDiscountList();
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
  const fetchData = async () => {
    if (mode === "add") {
      handleEntryNo();

      // Add first row if none exists
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }

      // Set default warehouse if exists
      const defaultWarehouse = getDefaultWarehouse();
      if (defaultWarehouse) {
        setValue("location", defaultWarehouse.value);
      }
    }

    handleProductsList();
    handleTaxList();
    handleUnitList();
    handlesalesData();
    handleDiscountList();
  };

  fetchData();
}, [branchsettings, warehouses]);

  const [products, setProducts] = useState([]);

  const handleProductsList = async () => {
    try {
      const formattedProducts = productList?.map((product) => ({
        label: product.name,
        value: product.guid,
        // carried so the picker can be searched by barcode as well as by name
        barcode: `${product.barcode ?? ""}`,
        barcodes: product.barcodes || [],
        code: `${product.code ?? ""}`,
      }));
      setProducts(formattedProducts);
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };
  async function getCustomerByGuid(guid) {
    const response = await getCustomersList(branch);
    const filteredData = response.data?.filter(
      (customer) => customer.guid === guid
    );
    return filteredData[0];
  }

  async function getUnitByGuid(guid) {
    const unitData = await getUnitList();
    const filteredData = unitData?.filter((unit) => unit.guid === guid);
    return filteredData[0];
  }

  async function getTaxByGuid(guid) {
    const taxData = await getTaxList();
    const filteredData = taxData?.filter((tax) => tax.guid === guid);
    return filteredData[0];
  }

  async function getProductByGuid(guid) {
    const productData = await getProductList(branch);

    const filteredData = productData?.filter(
      (product) => product.guid === guid
    );

    return filteredData[0];
  }

  // const handleFormSubmit = async (formdata) => {
  //   console.log(getValues().row);
  // };
  const handleFormSubmit = async (formdata) => {
    const objsales = new InvSales();
    const objfinance = new FinancialYear();
    if (mode === "edit") {
      objsales.guid = data?.guid;
      objsales.id = data?.id;
    }
    objsales.entrynumber = formdata?.entrynumber || 0;
    objsales.branch = branch;
    // objsales.Entrynumber = formdata.invoiceNo || "";
    objsales.invdate = dayjs(formdata?.invdate)?.format("YYYY-MM-DDTHH:mm:ss");
    objsales.deliveryDate = dayjs(formdata?.deliveryDate)?.format(
      "YYYY-MM-DDTHH:mm:ss"
    );
    objsales.salesPaymentType = formdata?.paymentType;
    objsales.salesTransType = 2;
    objsales.reftype = formdata?.referencetype || 0;
    objsales.refNo = formdata?.refNo || "";
    const customerData = customerList?.find((e) => e.guid == formdata?.customer);
    objsales.location = formdata.location;
    objsales.updatedUser = `${userId?.id}`;
    objsales.createdUser = `${userId?.id}`;
    objsales.customer = customerData;
    objsales.currency = "00000000-0000-0000-0000-000000000000";

    objsales.dispatch = formdata?.dispatch || "";
    objsales.dispatchTrough = formdata?.dispatchTrough || "";
    objsales.salesMode = formdata?.salesMode || 0;
    objsales.paid = Number(formdata?.paid) || 0;
    objsales.change = Number(formdata.change) || 0.0;
    objsales.additionalAmt = Number(formdata.addition) || 0.0;
    objsales.discAmt = Number(formdata.subtraction) || 0;
    objsales.roundOff = Number(formdata.round) || 0;
    objsales.grossTotal = totalGross || 0.0;
    objsales.discountTotal = totalDiscount || 0.0;
    objsales.taxTotal = totalTax || 0.0;
    objsales.netTotal = totalNet || 0.0;
    objsales.customerName = formdata.customerName || "";
    objsales.customerContactno = formdata.customerContactno || "";
    objsales.terms = formdata.terms || "";
    // guid of the selected branch user - API/DB column still required
    objsales.salesman = formdata?.salesman || null;

    applyTender(objsales, {
      tender,
      paymentType: formdata.paymentType,
      netTotal: totalNet,
    });
    // which card machine took an online payment - there is no column for it
    // yet, see docs/BACKEND-COMPLETE.md (Part 5)
    objsales.paymentCard = formdata.paymentCard || null;

    objfinance.id = branchsettings?.defaultFinancialYearID;
    objsales.financialYear = objfinance;
    objsales.Company = companyInfolist[0];
   
    const detailObj = formdata?.items?.filter((e) => !isBlankRow(e))?.map((e) => {
      const defaultDiscountobj = new DiscountClass();
      const defaultTaxobj = new TaxClass();

      let product;
      const productValue = e.product || e.product.value;

      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList.find((item) => item.guid == e.unit);
      const taxPercentage=taxData?.find((item)=>item.guid==e.taxPercentage)?.value

      const expiry = e.expiry
        ? dayjs(e.expiry).format("YYYY-MM-DDTHH:mm:ss")
        : dayjs().format("YYYY-MM-DDTHH:mm:ss");

      const detailObj = {
        product,
        variantID: e.variantID || null,
        unit,
        batch: e.batch,
        expiryDate: expiry,
        quantity: e.quantity,
        price: e.price,
        mrp: e.mrp || 0.0,
        foc: e.foc || 0.0,
        taxamnt: e.taxAmount,
        grossAmount: e.gross,
        netAmt: e.netTotal,
        discAmt: e.discountAmount,
        discPercentage: e.discountPercentage,
        taxPercentage,
        // per-line note, saved in Inv_SalesDetail.DETAILS
        details: e.notes || "",
      };

      return detailObj;
    });
    objsales.invSalesDetails = detailObj;
    try {
      const response = await addEditSales(objsales);
      console.log(response,"salessssssss");
      
      // success is a literal true (G-2) - a 200 "false" is a failure
      if (response?.data !== true) {
        toast.error(response?.data?.Message || "Not saved - please try again");
      } else {
        toast.success("Success");
        // print before the modal unmounts - handlePrint reads the live form
        if (printOnSaveRef.current) {
          handlePrint(printPrefs?.format || "A4");
          printOnSaveRef.current = false;
        }
        handleRefresh(); // Refresh the list
        handleClose(); // Close the modal
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "Unexpected error occured");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "Unexpected error occured"
      );
    }
  };

 

  // const printA4Function = () => {
  //   const form = document.getElementById("invoice-content");
  
  //   if (!form) {
  //     console.error("Element with ID 'invoice-content' not found.");
  //     return;
  //   }
  
  //   // Extract required values from form inputs

  //   const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
  //   const date = form.querySelector("input[name='invdate']")?.value || "";
  //   const deliveryDate = form.querySelector("input[name='deliveryDate']")?.value || "";
  //   const customerName = form.querySelector("input[name='customerName']")?.value || "";
  //   const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
  //   const discount = form.querySelector("input[name='discount']")?.value || "";
  //   const taxTotal = form.querySelector("input[name='taxTotal']")?.value || "";
  //   const netTotal = form.querySelector("input[name='netTotal']")?.value || "";
  
  //   // Extract table data
  //   const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map((row) => {
  //     return {
  //       description: row.querySelector(".description")?.innerText || "",
  //       rate: row.querySelector(".rate")?.innerText || "",
  //       qty: row.querySelector(".qty")?.innerText || "",
  //       total: row.querySelector(".total")?.innerText || "",
  //     };
  //   });
  
  //   // Generate printable content
  //   const printableContent = `
  //     <html>
  //       <head>
  //         <title>Invoice</title>
  //         <style>
  //           body { font-family: Arial, sans-serif; padding: 20px; }
  //           table { width: 100%; border-collapse: collapse; margin-top: 10px; }
  //           th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
  //           .text-right { text-align: right; }
  //         </style>
  //       </head>
  //       <body>
  //         <h2>Invoice</h2>
  //         <p><strong>Entry No:</strong> ${entryNumber}</p>
  //         <p><strong>Date:</strong> ${date}</p>
  //         <p><strong>Delivery Date:</strong> ${deliveryDate}</p>
  //         <p><strong>Customer Name:</strong> ${customerName}</p>
  //         <p><strong>Contact Number:</strong> ${contactNumber}</p>
  
  //         <table>
  //           <thead>
  //             <tr>
  //               <th>Description</th>
  //               <th>Rate</th>
  //               <th>Qty</th>
  //               <th>Total</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             ${tableRows
  //               .map(
  //                 (row) => `
  //               <tr>
  //                 <td>${row.description}</td>
  //                 <td>${row.rate}</td>
  //                 <td>${row.qty}</td>
  //                 <td>${row.total}</td>
  //               </tr>
  //             `
  //               )
  //               .join("")}
  //           </tbody>
  //         </table>
  
  //         <p><strong>Discount:</strong> ${discount}</p>
  //         <p><strong>Tax Total:</strong> ${taxTotal}</p>
  //         <p><strong>Net Total:</strong> ${netTotal}</p>
  
  //       </body>
  //     </html>
  //   `;
  
  //   // Open print window
  //   const newWindow = window.open("", "_blank");
  //   newWindow.document.write(printableContent);
  //   newWindow.document.close();
  
  //   // Delay print execution to ensure styles are applied
  //   setTimeout(() => {
  //     newWindow.print();
  //     newWindow.onafterprint = () => newWindow.close(); // Auto-close after printing
  //   }, 500);
  // };
  
// QR for every print of this invoice: ZATCA's Phase-2 QR when the branch is on
// ZATCA, else the Phase-1 QR when "Generate QR code in bill print" is on
const qrForPrint = (sellerName, invoiceTotal, vatTotal) =>
  zatcaPrintQr({ branchID: branch?.guid, entryNumber: watch("entrynumber"), transType: "SI" }, {
    enabled: branchsettings?.generateQrCodeInBillPrint === true,
    sellerName: sellerName || companyInfolist?.[0]?.name || "",
    vatNumber: companyInfolist?.[0]?.tin || "",
    timestamp: zatcaTimestamp(watch("invdate")),
    total: invoiceTotal,
    vat: vatTotal,
  });


  const printA4Function = async() => {
    const form = document.getElementById("invoice-content");
  
    if (!form) {
      console.error("Element with ID 'invoice-content' not found.");
      return;
    }

   // const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info
const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";
    // const companyPhone = company.phone || "";
    // const companyVAT = company.tin || "";
    // Extract values from form inputs
    

    
         const supplierGuid = watch("customer");
   const supplierObj = customerList.find(sup => sup.guid === supplierGuid) || {};
   const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
   const supplierAddress1 = supplierObj.address1 || "";
   const supplierMobile = supplierObj.mobile || "";
   const supplierVAT = supplierObj.gstNo || "";   
    
    const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";

const date = new Date(watch("invdate")).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
const invDateValue = watch("invdate") || new Date().toISOString();
  const invoiceDate = new Date(invDateValue).toISOString();
    const customerName = form.querySelector("input[name='customerName']")?.value || "";
    const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
    const fields = watch("items") || [];
// const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
// const taxTotal = fields.reduce((sum, item) => sum + (parseFloat(item.taxAmount) || 0), 0);
const netTotal = Number(totalNet) || 0; // the bill total (discount, addition and round off included)
// const addition = parseFloat(watch("addition")) || 0;
// const round = parseFloat(watch("round")) || 0;
// Store the totals in React Hook Form
// setValue("discount", discount.toFixed(2));
// setValue("taxTotal", taxTotal.toFixed(2));
// setValue("netTotal", netTotal.toFixed(2));

const grossTotalPrint = Number(totalGross) || 0;
const discountPrint = Number(totalDiscount) || 0;
const taxTotalPrint = Number(totalTax) || 0;
const netTotalPrint = Number(totalNet) || 0;

const additionPrint = Number(watch("addition")) || 0;
const roundPrint = Number(watch("round")) || 0;


console.log({ totalDiscount, totalTax, totalNet });

  
    // Extract table data
  

  // const tableRows = Array.from(form.querySelectorAll("table tbody tr")).map(row => {
  //   // Query the react-select component for the current row
  //   const selectContainer1 = row?.querySelector('.css-b62m3t-container');
  //   const selectContainer = selectContainer1?.querySelector('.react-select__control');
  //   const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
  //   const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
  
  //   // Extract the text or value of the selected option
  //   const selectedValue = selectedValueDiv?.textContent || "N/A";
  
  //   // Extract other values from the row (quantity, rate, total)
  //   return {
  //     description: selectedValue,
  //     qty: parseInt(row.querySelector("td:nth-child(6) input")?.value?.trim()) || 0,
  //     rate: parseFloat(row.querySelector("td:nth-child(7) input")?.value?.trim()) || 0.00,
  //     total: parseFloat(row.querySelector("td:nth-child(10) input")?.value?.trim()) || 0.00
  //   };
  // });
const paymentTypeLabel =
  paymentType?.find(p => p.value === watch("paymentType"))?.label || "";


  //     const tableRows = Array.from(form.querySelectorAll("tbody tr")).map((row, index) => ({
  //   description: row.querySelector('td[data-label="Description"]')?.innerText || "",
  //   code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
  //   hsnCode: row.querySelector('td[data-label="HSN Code"] input')?.value || "",
  //   qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
  //   unit: row.querySelector('td[data-label="Unit"] input')?.value || "",
  //   rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
  //   discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
  //   tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
  //   total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
  //   netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
  // }));
  const tableRows = Array.from(form.querySelectorAll("tbody tr"))
    .filter(
      (row) =>
        parseFloat(
          row.querySelector('td[data-label="Quantity"] input')?.value || 0
        ) > 0
    )
    .map((row) => {
  const unitText =
    row
      .querySelector('td[data-label="Unit"] .react-select__single-value')
      ?.textContent || "";

  return {
    description: row.querySelector('td[data-label="Description"]')?.innerText || "",
    code: row.querySelector('td[data-label="Barcode"] input')?.value || "",
    qty: parseFloat(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
    unit: unitText,
    rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value || 0),
    tax: parseFloat(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
      discount: parseFloat(row.querySelector('td[data-label="Discount Amount"] input')?.value || 0),
    total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value || 0),
    netTotal: parseFloat(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
  };
});

  console.log(tableRows,"lkkk");

  // const qrData = `Company: ${companyName}\nDate: ${date}\nDelivery Date: ${deliveryDate}\nNet Total: ${netTotal.toFixed(2)}`;
    
  //   const qrCodeUrl = await QRCode.toDataURL(qrData);

  const qrCodeUrl = await qrForPrint(companyName, netTotalPrint, taxTotalPrint);
  
    // Generate printable content
    // const printableContent = `
    //   <html>
    //     <head>
    //       <title>Invoice</title>
    //       <style>
    //         body { font-family: Arial, sans-serif; padding: 20px; }
    //         table { width: 100%; border-collapse: collapse; margin-top: 10px; }
    //         .header { text-align: center; margin-bottom: 20px; }
    //         .qr-code { text-align: center; margin-top: 20px;}
    //         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
    //         .text-right { text-align: right; }
    //         .totals-table { width: 100%; margin-top: 20px; border-collapse: collapse; }
    //         .totals-table td { border: none; padding: 5px; font-weight: bold; }
    //         .totals-table .label { text-align: right; width: 80%; }
    //         .totals-table .value { text-align: right; width: 20%; }
    //         @media print {
    //           body { margin: 0; }
    //         }
    //       </style>
    //     </head>
    //     <body>
    //       <div class="qr-code">
    //         <img src="${qrCodeUrl}" alt="QR Code" />
    //       </div>
    //      <div class="header">
    //         <h2>${companyName}</h2>
    //         <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
    //         <p>Phone: ${companyPhone}</p>
    //       </div>
         
    //       <p><strong>Entry No:</strong> ${entryNumber}</p>
    //       <p><strong>Date:</strong> ${date}</p>
    //       <p><strong>Delivery Date:</strong> ${deliveryDate}</p>
    //       <p><strong>Customer Name:</strong> ${customerName}</p>
    //       <p><strong>Contact Number:</strong> ${contactNumber}</p>
  
    //       <table>
    //         <thead>
    //           <tr>
    //             <th>Description</th>
    //             <th>Rate</th>
    //             <th>Qty</th>
    //             <th>Total</th>
    //           </tr>
    //         </thead>
    //         <tbody>
    //           ${tableRows
    //             .map(
    //               (row) => `
    //             <tr>
    //               <td>${row.description}</td>
    //               <td class="text-right">${row.rate.toFixed(2)}</td>
    //               <td class="text-right">${row.qty}</td>
    //               <td class="text-right">${row.total.toFixed(2)}</td>
    //             </tr>
    //           `
    //             )
    //             .join("")}
    //         </tbody>
    //       </table>
  
    //       <table class="totals-table">
    //         <tr>
    //           <td class="label">Discount:</td>
    //           <td class="value">${discount}</td>
    //         </tr>
    //         <tr>
    //           <td class="label">Tax Total:</td>
    //           <td class="value">${taxTotal}</td>
    //         </tr>
    //         <tr>
    //           <td class="label">Net Total:</td>
    //           <td class="value">${netTotal}</td>
    //         </tr>
    //       </table>
    //     </body>
    //   </html>
    // `;
  

const amountInWords = (num) => {
  if (!num || isNaN(num)) return "";

  const a = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const numberToWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + numberToWords(n % 100) : "")
      );
    if (n < 1000000)
      return (
        numberToWords(Math.floor(n / 1000)) +
        " Thousand" +
        (n % 1000 ? " " + numberToWords(n % 1000) : "")
      );
    return "";
  };

  const integerPart = Math.floor(num);
  const decimalPart = Math.round((num - integerPart) * 100);

  const riyalPart = numberToWords(integerPart);
  const halalahPart = decimalPart ? numberToWords(decimalPart) : "";

  return `${riyalPart} Riyal${
    halalahPart ? " and " + halalahPart + " Halalah" : ""
  } Only`;
};


const printableContent = `
<!DOCTYPE html>
<html lang="ar">
<head>
<meta charset="UTF-8" />
<title>Tax Invoice</title>

<style>
@page { size: A4; margin: 10mm; }

body {
  font-family: Arial, sans-serif;
  font-size: 11px;
  color: #000;
}

.center { text-align: center; }
.left { text-align: left; direction: ltr; }
.right { text-align: right; direction: rtl; }
.bold { font-weight: bold; }
.header h2 {
  margin: 2px 0;
}
.header p { margin: 2px 0; }

.invoice-title {
  margin: 16px 16px;
  font-weight: bold;
  
}

/* DEFAULT TABLE */
table {
  width: 100%;
  border-collapse: collapse;
}

/* HEADER & INFO TABLES */
th {
  border: 1px solid #000;
  padding: 4px;
}

.header table td,
table:not(.items) td {
  border: 1px solid #000;
  padding: 4px;
}

/* ITEMS TABLE OUTER BORDER */
.items {
  border: 1px solid #000;
}

/* ITEM HEADER GRID */
.items thead th {
  border: 1px solid #000;
}

/* ITEM BODY — NO VERTICAL LINES */
/* ITEM BODY — ONLY VERTICAL LINES (REFERENCE STYLE) */
.items tbody td {
  border-top: none;
  border-bottom: none;
  border-left: 1px solid #000;
  border-right: 1px solid #000;
  padding: 6px 4px;
  text-align: center;
  height: 26px;
}




/* BOTTOM BORDER OF ITEMS */
.items tbody tr:last-child td {
  border-bottom: 1px solid #000;
}


.small { font-size: 10px; }

.no-border tr td { border: none; }

.items th { font-size: 10px; }
.items td { font-size: 11px; text-align: center; }

/* FORCE ITEM TABLE HEIGHT */
.items tbody {
  height: 380px;
}
.totals{
border: 1px solid #000;
}
.totals tr td {
   border-top: none;
  border-bottom: none;
  border-left: none;
  border-right: none;
  padding: 6px 4px;
}
.totals td:last-child {
  border-left: 1px solid #000;
}

.footer-fixed {
  margin-top: 8px;
  font-size: 10px;
  border: 1px solid #000;
}

.footer-fixed tr td {
  border: none;
}
</style>
</head>

<body>

<!-- HEADER (UNCHANGED AS REQUESTED) -->
<div class="header center">
<h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>

 

  <div class="invoice-title">TAX INVOICE &nbsp;&nbsp; الفاتورة الضريبية</div>
</div>

<!-- INVOICE INFO -->
<table>
<tr>
  <td class="left small"><b>Invoice No :</b> ${entryNumber}</td>
  <td class="center small"><b>Date :</b> ${date}</td>
  <td class="right small"><b>Type :</b> ${paymentTypeLabel}</td>
</tr>
</table>

<!-- CUSTOMER DETAILS -->
<table style="margin-top:4px;">
<tr>
  <th colspan="4" class="center small">CUSTOMER DETAILS &nbsp;&nbsp; تفاصيل العميل</th>
</tr>
<tr>
  <td class="left small"><b>NAME</b></td>
  <td class="left">${supplierName}</td>
  <td></td>
  <td class="right small"><b>اسم</b></td>

</tr>
<tr>
  <td class="left small"><b>CONTACT</b></td>
  <td class="left">${supplierMobile}</td>
  <td>${supplierMobile}</td>
  <td class="right small"><b>رقم الاتصال</b></td> 
</tr>
<tr>
  <td class="left small"><b>VAT NO</b></td>
  <td class="left">${supplierVAT}</td>
    <td>${supplierVAT}</td>
  <td class="right small"><b>الرقم الضريبي</b></td>

</tr>
<tr>
  <td class="left small"><b>CR NO</b></td>
  <td class="left"></td>
    <td></td>
  <td class="right small"><b>رقم السجل التجاري</b></td>

</tr>
<tr>
  <td class="left small"><b>ADDRESS</b></td>
  <td colspan="3">${supplierAddress1}</td>
</tr>
</table>

<!-- ITEMS -->
<table class="items" style="margin-top:4px;">
<thead>
<tr>
  <th>Sl.No<br/>رقم</th>
  <th>Barcode<br/>الباركود</th>
  <th>Description<br/>الوصف</th>
  <th>Qty<br/>كمية</th>
  <th>Unit<br/>وحدة</th>
  <th>Unit Price<br/>سعر الوحدة</th>
  <th>Taxable Amt<br/>المبلغ الخاضع</th>
  <th>Tax Amt<br/>مبلغ الضريبة</th>
  <th>Total<br/>المجموع</th>
</tr>
</thead>

<tbody>
${
(() => {
  const minRows = 9;
  const emptyRows = minRows - tableRows.length;

  return `
  ${tableRows.map((row, i) => `
  <tr>
    <td>${i + 1}</td>
    <td>${row.code}</td>
    <td class="left">${row.description}</td>
    <td>${row.qty}</td>
    <td>${row.unit}</td>
    <td>${row.rate.toFixed(2)}</td>
    <td>${row.total.toFixed(2)}</td>
    <td>${row.tax.toFixed(2)}</td>
    <td>${row.netTotal.toFixed(2)}</td>
  </tr>
  `).join("")}

  ${Array.from({ length: Math.max(0, emptyRows) }).map(() => `
  <tr>
    <td>&nbsp;</td><td></td><td></td><td></td>
    <td></td><td></td><td></td><td></td><td></td>
  </tr>
  `).join("")}
  `;
})()
}
</tbody>
</table>

<!-- TOTALS -->
<table class="totals" style="margin-top:6px;">
<tr>
  <td class="left small">
VAT (${((taxTotalPrint / (netTotalPrint - taxTotalPrint)) * 100).toFixed(2)}%)
  </td>
  <td></td>
  <td class="right bold" style="padding-right:16px;">Total</td><td>المجموع</td> 
  <td class="right">${(netTotalPrint - taxTotalPrint).toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">VAT</td><td>ضريبة القيمة المضافة</td> 
  <td class="right">${taxTotalPrint.toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Discount </td><td> تخفيض</td> 
  <td class="right">${discountPrint.toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Sub Total </td><td>المجموع الفرعي</td> 
  <td class="right">${netTotal.toFixed(2)}</td>
</tr>

<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Addition</td><td>إضافة</td> 
  <td class="right">${additionPrint.toFixed(2)}</td>
</tr>
<tr>
  <td colspan="2"></td>
  <td class="right bold" style="padding-right:16px;">Round off</td><td >تقريب</td> 
  <td class="right">${roundPrint.toFixed(2)}</td>
</tr>
<tr>
  <td class="left bold">
     ${amountInWords(netTotalPrint)}
  </td>
  <td></td>
  <td class="right bold" style="padding-right:16px;">Net Total</td><td class="bold">صافي المجموع</td> 
  <td class="right bold">${netTotalPrint.toFixed(2)}</td>
</tr>
</table>

<!-- QR & FOOTER -->
<table class="footer-fixed">
<tr>
  <td class="left" style="padding-left:20px;">
    ${qrCodeUrl ? `<img src="${qrCodeUrl}" width="100" />` : ""}
  </td>
  <td class="right bold" style="font-size:12px; padding-right:20px;">
    For ${companyName}<br/>
  </td>
</tr>
</table> 

</body>
</html>
`;



    // Create an iframe for better printing
    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.width = "0px";
    iframe.style.height = "0px";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
  
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(printableContent);
    doc.close();
  
    iframe.contentWindow.focus();
    setTimeout(() => {
      iframe.contentWindow.print();
      iframe.contentWindow.onafterprint = () => document.body.removeChild(iframe);
    }, 500);
  };
  





const  thermalPrintFunction = async() => {
  const form = document.getElementById("invoice-content");

  if (!form) {
      console.error("Element with ID 'invoice-content' not found.");
      return;
  }

const company = printSettings?.[0] ?? {};

    // Extract company details
    const companyName = company.companyName;
    const otherLanguage = company.otherLanguage;
    const companyAddress1 = company.header1 ;
    const companyAddress2 = company.header2 ;
    const companyAddress3 = company.header3 ;
    const companyAddress4 = company.header4;
    const companyAddress5 = company.header5 ;
  //const companyPhone = company.phone || "";
  //const companyVAT = company.tin || "";
const footerText1= company.footerText1 ;
const footerText2= company.footerText2 ;

  // Helper function to get input values safely
  const entryNumber = form.querySelector("input[name='entrynumber']")?.value || "";
   
    
  // const date = watch("invdate"); // Automatically updates when field changes
  // const deliveryDate = watch("deliveryDate");
  const date = new Date(watch("invdate")).toLocaleDateString("en-GB"); // Format: DD/MM/YYYY
  const deliveryDate = new Date(watch("deliveryDate")).toLocaleDateString("en-GB");
  const invDateValue = watch("invdate") || new Date().toISOString();
  const invoiceDate = new Date(invDateValue).toISOString();
      const customerName = form.querySelector("input[name='customerName']")?.value || "";
      const contactNumber = form.querySelector("input[name='customerContactno']")?.value || "";
      
      const fields = watch("items") || [];

  // Calculate totals
  const discount = fields.reduce((sum, item) => sum + (parseFloat(item.discountAmount) || 0), 0);
  const taxTotal = Number(totalTax) || 0;
  const netTotal = Number(totalNet) || 0; // the bill total (discount, addition and round off included)

  // Store the totals in React Hook Form
  setValue("discount", discount.toFixed(2));
  setValue("taxTotal", taxTotal.toFixed(2));
  setValue("netTotal", netTotal.toFixed(2));
    
 

  // Extract table data
 
  const tableRows = Array.from(form.querySelectorAll("table tbody tr"))
    .filter(
      (row) =>
        parseFloat(
          row.querySelector('td[data-label="Quantity"] input')?.value || 0
        ) > 0
    )
    .map(row => {
    // Query the react-select component for the current row
    const selectContainer1 = row?.querySelector('.css-b62m3t-container');
    const selectContainer = selectContainer1?.querySelector('.react-select__control');
    const selectContainer3 = selectContainer?.querySelector('.react-select__value-container');
    const selectedValueDiv = selectContainer3?.querySelector('.react-select__single-value');
  
    // Extract the text or value of the selected option
    const selectedValue = selectedValueDiv?.textContent || "N/A";
  
    // Extract other values from the row (quantity, rate, total)
    return {
      description: selectedValue,
      qty: parseInt(row.querySelector('td[data-label="Quantity"] input')?.value?.trim()) || 0,
      rate: parseFloat(row.querySelector('td[data-label="Price"] input')?.value?.trim()) || 0.00,
      total: parseFloat(row.querySelector('td[data-label="Gross"] input')?.value?.trim()) || 0.00
    };
  });
   
  // const qrData = `Seller's Name: ${companyName}\nInvoice Date/Time: ${date}\nInvoice Total(with VAT ): ${netTotal.toFixed(2)}`;
    
  // const qrCodeUrl = await QRCode.toDataURL(qrData);

  const qrCodeUrl = await qrForPrint(companyName, netTotal, taxTotal);

  // Format content for thermal printing (3-inch width)
  const printableContent = `
  <html>
  <head>
    <title>Receipt</title>
    <style>
      body { 
        font-family: Arial, sans-serif; 
        font-size: 8vw; /* Responsive font size */
        width: 100%; 
        max-width: 300px; /* Ensures it fits on small screens */
        margin: 0 auto; /* Center content */
        padding: 0;
        word-wrap: break-word; /* Prevents overflow */
      }
      .header { text-align: center;}
      .header h2{
      margin: 1px 0;
      }
      .header p{  
      margin :1px 0;
      }

       .qr-code { text-align: center; margin-top: 20px;}
      .center { text-align: center; }
      .bold { font-weight: bold; }
      .uppercase { text-transform: uppercase; }
      .line { border-top: 2px dashed black; margin: 12px 0; } 
      .table { width: 100%; border-collapse: collapse; font-size: 8vw; } /* Responsive table font */
      .table td {
        padding: 8px; /* More spacing */
        word-wrap: break-word;
      }
      .right { text-align: right; }
      .title { font-size: 10vw; } /* Scales title */
      .total { font-size: 10vw; font-weight: bold; } /* Larger total */
      
      /* Responsive design for smaller screens */
      @media (max-width: 400px) {
        body { font-size: 4.5vw; }
        .table { font-size: 4.5vw; }
        .title, .total { font-size: 4.5vw; }
      }
 
      @media (min-width: 600px) {
        body { font-size: 10px; }
        .table { font-size: 10px; }
        .title, .total { font-size: 15px; }
      }

     @media print {
        @page { margin: 5mm; } /* Adds margin for print */
        body { margin: 0; padding: 0; }
        .line { margin: 10px 0; }
      }
    </style>
  </head>
  <body>
   
  <div class="header">
         <h2>${otherLanguage}</h2>
  <h2>${companyName}</h2>
 
  <p>${companyAddress1}</p>
  <p>${companyAddress2}</p>
  <p>${companyAddress3}</p>
  <p>${companyAddress4}</p>
  <p>${companyAddress5}</p>
          </div>
    
    <div class="line"></div>
    <div>Entry No: ${entryNumber}</div>
    <div>Date: ${new Date(date).toLocaleDateString()}</div>
    <div>Delivery Date: ${new Date(deliveryDate).toLocaleDateString()}</div>
    <div>Customer: ${customerName}</div>
    <div>Contact: ${contactNumber}</div>
    <div class="line"></div>

    <table class="table">
      <tr class="bold">
        <td>Description</td>
        <td class="right">Qty</td>
        <td class="right">Rate</td>
        <td class="right">Total</td>
      </tr>
      ${tableRows.map(row => ` 
        <tr>
          <td>${row.description}</td>
          <td class="right">${row.qty}</td>
          <td class="right">${row.rate.toFixed(2)}</td>
          <td class="right">${row.total.toFixed(2)}</td>
        </tr>
      `).join("")}
    </table>

    <div class="line"></div>
    <table class="table">
      <tr>
        <td class="bold">Discount:</td>
        <td class="right">${discount.toFixed(2)}</td>
      </tr>
      <tr>
        <td class="bold">Tax:</td>
        <td class="right">${taxTotal.toFixed(2)}</td>
      </tr>
      <tr>
        <td class="bold total">Total:</td>
        <td class="right total">${netTotal.toFixed(2)}</td>
      </tr>
    </table>
    <div class="line"></div>
    <div class="center bold" style="font-size: 5vw;">${footerText1}</div>
    <div class="center bold" style="font-size: 5vw;">${footerText2}</div>
    <div class="center" style="font-size: 3vw;">Copyright(C)ezyERP .www.ezyerp.net</div>
    ${qrCodeUrl ? `<div class="qr-code">
            <img src="${qrCodeUrl}" alt="QR Code" />
          </div>` : ""}
  </body>
</html>




  `;

  // Print via iframe
  const iframe = document.createElement("iframe");
  iframe.style.position = "absolute";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "none";
  document.body.appendChild(iframe);

  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(printableContent);
  doc.close();

  iframe.contentWindow.focus();
  setTimeout(() => {
      iframe.contentWindow.print();
      iframe.contentWindow.onafterprint = () => iframe.remove();
  }, 500);
};



const amountInWords = (num) => {
  if (!num || isNaN(num)) return "";

  const a = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const b = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const numberToWords = (n) => {
    if (n < 20) return a[n];
    if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
    if (n < 1000)
      return (
        a[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 ? " " + numberToWords(n % 100) : "")
      );
    if (n < 1000000)
      return (
        numberToWords(Math.floor(n / 1000)) +
        " Thousand" +
        (n % 1000 ? " " + numberToWords(n % 1000) : "")
      );
    return "";
  };

  const integerPart = Math.floor(num);
  const decimalPart = Math.round((num - integerPart) * 100);

  const riyalPart = numberToWords(integerPart);
  const halalahPart = decimalPart ? numberToWords(decimalPart) : "";

  return `${riyalPart} Riyal${
    halalahPart ? " and " + halalahPart + " Halalah" : ""
  } Only`;
};


const pdfFunction = async () => {
  const doc = new jsPDF("p", "mm", "a4");

  /* ================= DATA ================= */
const company = printSettings?.[0] ?? {};

console.log("Company Info for Printing:", company); 
    // Extract company details
    const companyName = company.companyName || "Company Name";
    const otherLanguage = company.otherLanguage || "";
    const companyAddress1 = company.header1 || "";
    const companyAddress2 = company.header2 || "";
    const companyAddress3 = company.header3 || "";
    const companyAddress4 = company.header4 || "";
    const companyAddress5 = company.header5 || "";
  const items = watch("items") || [];
  const date = new Date(watch("invdate")).toLocaleDateString("en-GB");

  const supplierGuid = watch("customer");
  const supplierObj =
    customerList.find(sup => sup.guid === supplierGuid) || {};

  const supplierName = supplierObj.name || supplierObj.ledger || "N/A";
  const supplierAddress1 = supplierObj.address1 || "";
  const supplierMobile = supplierObj.mobile || "";
  const supplierVAT = supplierObj.gstNo || "";

  const paymentTypeLabel =
    paymentType?.find(p => p.value === watch("paymentType"))?.label || "";

  /* ================= PAGE BORDER ================= */
  doc.rect(5, 5, 200, 287);

  /* ================= COMPANY HEADER ================= */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(companyName || "", 105, 12, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(companyAddress1, 80, 18, { align: "center" });
  doc.text(companyAddress2, 100, 18, { align: "center" });
  doc.text(companyAddress3 || "", 125, 18, { align: "center" });
  doc.text(companyAddress4 || "", 80, 22, { align: "center" });
  doc.text(companyAddress5 || "", 115, 22, { align: "center" });

  /* ================= TITLE ================= */
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("TAX INVOICE", 105, 32, { align: "center" });

  /* ================= META ROW ================= */
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);

  doc.rect(5, 36, 200, 10);
  doc.line(75, 36, 75, 46);
  doc.line(140, 36, 140, 46);

  doc.text(`Invoice No : ${watch("entrynumber")}`, 7, 43);
  doc.text(`Date : ${date}`, 77, 43);
  doc.text(`Type : ${paymentTypeLabel}`, 142, 43);

  /* ================= CUSTOMER DETAILS ================= */
  doc.setFont("helvetica", "bold");
 doc.line(5, 56, 205, 56);
  doc.text("CUSTOMER DETAILS", 105, 54, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.rect(5, 46, 200, 40);
  doc.line(105, 56, 105, 86);

  doc.line(5, 64, 205, 64);
  doc.line(5, 72, 205, 72);
  // doc.line(5, 80, 205, 80);
  // doc.line(5, 88, 205, 88);

  doc.text("NAME", 7, 62);
  doc.text(supplierName, 35, 62);

  doc.text("CONTACT", 7, 70);
  doc.text(supplierMobile, 35, 70);

  doc.text("VAT NO", 107, 70);
  doc.text(supplierVAT, 135, 70);

  doc.text("ADDRESS", 7, 78);
  doc.text(supplierAddress1, 35, 78);

  doc.text("CR NO", 107, 62);
  doc.text("-", 135, 62);

  /* ================= ITEMS TABLE ================= */
  const startY = 86;
  const rowH = 8;
  const tableHeight = 120;

  const colX = [5, 15, 35, 85, 100, 115, 135, 155, 175, 205];

  doc.rect(5, startY, 200, tableHeight);
  colX.forEach(x => doc.line(x, startY, x, startY + tableHeight));

  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);

  const headers = [
    "#",
    "Code",
    "Description",
    "Qty",
    "Unit",
    "Rate",
    "Taxable",
    "VAT",
    "Total",
  ];

  headers.forEach((h, i) => {
    doc.text(h, colX[i] + 2, startY + 6);
  });

  doc.line(5, startY + rowH, 205, startY + rowH);

  doc.setFont("helvetica", "normal");

  items.forEach((item, i) => {
    const y = startY + rowH * (i + 1) + 6;

    const product = productList.find(p => p.guid === item.product);
    const unit = unitList.find(u => u.guid === item.unit);

    doc.text(String(i + 1), colX[0] + 2, y);
    doc.text(product?.code || "", colX[1] + 2, y);
    doc.text(product?.name || "", colX[2] + 2, y);
    doc.text(String(item.quantity || 0), colX[3] + 2, y);
    doc.text(unit?.name || "", colX[4] + 2, y);
    doc.text(Number(item.price || 0).toFixed(2), colX[5] + 2, y);
    doc.text(Number(item.gross || 0).toFixed(2), colX[6] + 2, y);
    doc.text(Number(item.taxAmount || 0).toFixed(2), colX[7] + 2, y);
    doc.text(Number(item.netTotal || 0).toFixed(2), colX[8] + 2, y);

    doc.line(
      5,
      startY + rowH * (i + 2),
      205,
      startY + rowH * (i + 2)
    );
  });

  /* ================= FOOTER ================= */

// let footerStartY = startY + tableHeight + 5;

const PAGE_BOTTOM = 280;
const FOOTER_HEIGHT = 70;

let footerStartY = PAGE_BOTTOM - FOOTER_HEIGHT;


// A4 safety
if (footerStartY + 70 > 280) {
  doc.addPage();
  footerStartY = 20;
}

// Footer container
const footerHeight = 70;
doc.rect(5, footerStartY, 200, footerHeight);

// Divider between totals & QR
doc.line(5, footerStartY + 40, 205, footerStartY + 40);

// Vertical divider for totals (top half only)
doc.line(120, footerStartY, 120, footerStartY + 40);

/* ===== RIGHT SIDE TOTALS ===== */
const grossTotal = items.reduce((s, i) => s + Number(i.gross || 0), 0);
const taxTotal = Number(totalTax) || 0;
const netTotal = Number(totalNet) || 0; // the bill total (discount, addition and round off included)

doc.setFont("helvetica", "normal");
doc.setFontSize(9);

const labelX = 125;
const valueX = 195;
let y = footerStartY + 8;
const gap = 5;

doc.text("Total", labelX, y);
doc.text(grossTotal.toFixed(2), valueX, y, { align: "right" });

y += gap;
doc.text("VAT", labelX, y);
doc.text(taxTotal.toFixed(2), valueX, y, { align: "right" });

y += gap;
doc.text("Discount", labelX, y);
doc.text("0.00", valueX, y, { align: "right" });

y += gap;
doc.text("Sub Total", labelX, y);
doc.text(netTotal.toFixed(2), valueX, y, { align: "right" });

y += gap;
doc.text("Addition", labelX, y);
doc.text("0.00", valueX, y, { align: "right" });

y += gap;
doc.text("Round off", labelX, y);
doc.text("0.00", valueX, y, { align: "right" });

// Net Total (bold, safely above divider)
y += gap;
doc.setFont("helvetica", "bold");
doc.text("Net Total", labelX, y);
doc.text(netTotal.toFixed(2), valueX, y, { align: "right" });

/* ===== LEFT SIDE ===== */
doc.setFont("helvetica", "normal");
doc.text("VAT (5.00%)", 7, footerStartY + 8);

doc.setFont("helvetica", "bold");
doc.text(
  `${amountInWords(netTotal)} Only`,
  7,
  footerStartY + 30
);

/* ===== QR + SIGNATURE ===== */
const qrY = footerStartY + 45;
  /* ================= ZATCA QR ================= */
  const qrImage = await qrForPrint(company.companyName, netTotal, taxTotal);
if (qrImage) doc.addImage(qrImage, "PNG", 10, qrY, 22, 22);

doc.setFont("helvetica", "bold");
doc.text(`For ${company.name || ""}`, 150, qrY + 14);


  /* ================= SAVE ================= */
  doc.save(`Invoice_${watch("entrynumber")}.pdf`);
};








// const buildPrintableContent = async () => {
//   const form = document.getElementById("invoice-content");
//   if (!form) return "";

//   /* ================= COMPANY ================= */
//   const company = companyInfolist?.[0] || {};
//   const companyName = company.name || "Company Name";
//   const companyAddress1 = company.address1 || "";
//   const companyAddress2 = company.address2 || "";
//   const companyAddress3 = company.address3 || "";
//   const companyPhone = company.phone || "";
//   const companyVAT = company.tin || "";

//   /* ================= CUSTOMER ================= */
//   const supplierGuid = watch("customer");
//   const supplierObj = customerList.find(c => c.guid === supplierGuid) || {};

//   const supplierName = supplierObj.name || "";
//   const supplierAddress1 = supplierObj.address1 || "";
//   const supplierMobile = supplierObj.mobile || "";
//   const supplierVAT = supplierObj.gstNo || "";

//   /* ================= INVOICE ================= */
//   const entryNumber = watch("entrynumber") || "";
//   const date = new Date(watch("invdate")).toLocaleDateString("en-GB");

//   const invDateValue = watch("invdate") || new Date().toISOString();
//   const invoiceDate = new Date(invDateValue).toISOString();

//   const paymentTypeLabel =
//     paymentType?.find(p => p.value === watch("paymentType"))?.label || "";

//   /* ================= ITEMS (DOM → PDF SAFE) ================= */
//   const tableRows = Array.from(form.querySelectorAll("tbody tr")).map(row => {
//     const unitText =
//       row.querySelector('td[data-label="Unit"] .react-select__single-value')
//         ?.textContent || "";

//     return {
//       description: row.querySelector('td[data-label="Description"]')?.innerText || "",
//       code: row.querySelector('td[data-label="Item Code"] input')?.value || "",
//       qty: Number(row.querySelector('td[data-label="Quantity"] input')?.value || 0),
//       unit: unitText,
//       rate: Number(row.querySelector('td[data-label="Price"] input')?.value || 0),
//       tax: Number(row.querySelector('td[data-label="Tax Amount"] input')?.value || 0),
//       total: Number(row.querySelector('td[data-label="Gross"] input')?.value || 0),
//       netTotal: Number(row.querySelector('td[data-label="Net Amount"] input')?.value || 0),
//     };
//   });

//   /* ================= TOTALS ================= */
//   const taxTotalPrint = Number(totalTax) || 0;
//   const discountPrint = Number(totalDiscount) || 0;
//   const netTotalPrint = Number(totalNet) || 0;
//   const additionPrint = Number(watch("addition")) || 0;
//   const roundPrint = Number(watch("round")) || 0;

//   /* ================= QR ================= */
//   const fatooraQRData = generateFatooraQR(
//     companyName,
//     companyVAT,
//     invoiceDate,
//     netTotalPrint.toFixed(2),
//     taxTotalPrint.toFixed(2)
//   );
//   const qrCodeUrl = await QRCode.toDataURL(fatooraQRData);

//   /* ================= BODY HTML ONLY ================= */
//   const printableContent = `
// <style>
// @page { size: A4; margin: 10mm; }
// body { font-family: Arial, sans-serif; font-size: 11px; color: #000; }
// table { width: 100%; border-collapse: collapse; }
// th, td { border: 1px solid #000; padding: 4px; }
// .center { text-align: center; }
// .left { text-align: left; }
// .right { text-align: right; }
// .bold { font-weight: bold; }
// .small { font-size: 10px; }
// .items tbody td { border-top: none; border-bottom: none; }
// .items tbody tr:last-child td { border-bottom: 1px solid #000; }
// .footer { border: 1px solid #000; margin-top: 6px; }
// .footer td { border: none; }
// </style>

// <div style="width:210mm; padding:10mm; background:#fff;">

// <!-- HEADER -->
// <div class="center">
//   <h2>${companyName}</h2>
//   <p>${companyAddress1}, ${companyAddress2}, ${companyAddress3}</p>
//   <p>Phone: ${companyPhone}</p>
//   <p><b>VAT:</b> ${companyVAT}</p>
//   <h3>TAX INVOICE | الفاتورة الضريبية</h3>
// </div>

// <!-- INFO -->
// <table>
//   <tr>
//     <td><b>Invoice No</b></td><td>${entryNumber}</td>
//     <td><b>Date</b></td><td>${date}</td>
//   </tr>
//   <tr>
//     <td><b>Payment</b></td><td>${paymentTypeLabel}</td>
//     <td></td><td></td>
//   </tr>
// </table>

// <!-- CUSTOMER -->
// <table style="margin-top:4px;">
//   <tr><th colspan="4" class="center">CUSTOMER DETAILS</th></tr>
//   <tr><td>Name</td><td>${supplierName}</td><td>Contact</td><td>${supplierMobile}</td></tr>
//   <tr><td>VAT</td><td>${supplierVAT}</td><td></td><td></td></tr>
//   <tr><td>Address</td><td colspan="3">${supplierAddress1}</td></tr>
// </table>

// <!-- ITEMS -->
// <table class="items" style="margin-top:6px;">
// <thead>
// <tr>
//   <th>#</th><th>Code</th><th>Description</th><th>Qty</th>
//   <th>Unit</th><th>Rate</th><th>Tax</th><th>Total</th>
// </tr>
// </thead>
// <tbody>
// ${tableRows.map((r, i) => `
// <tr>
//   <td>${i + 1}</td>
//   <td>${r.code}</td>
//   <td class="left">${r.description}</td>
//   <td>${r.qty}</td>
//   <td>${r.unit}</td>
//   <td>${r.rate.toFixed(2)}</td>
//   <td>${r.tax.toFixed(2)}</td>
//   <td>${r.netTotal.toFixed(2)}</td>
// </tr>
// `).join("")}
// </tbody>
// </table>

// <!-- TOTALS -->
// <table style="margin-top:6px;">
// <tr><td>Sub Total</td><td class="right">${(netTotalPrint - taxTotalPrint).toFixed(2)}</td></tr>
// <tr><td>VAT</td><td class="right">${taxTotalPrint.toFixed(2)}</td></tr>
// <tr><td>Discount</td><td class="right">${discountPrint.toFixed(2)}</td></tr>
// <tr><td>Addition</td><td class="right">${additionPrint.toFixed(2)}</td></tr>
// <tr><td>Round Off</td><td class="right">${roundPrint.toFixed(2)}</td></tr>
// <tr class="bold"><td>NET TOTAL</td><td class="right">${netTotalPrint.toFixed(2)}</td></tr>
// </table>

// <!-- FOOTER -->
// <table class="footer">
// <tr>
//   <td><img src="${qrCodeUrl}" width="90"/></td>
//   <td class="right bold">For ${companyName}</td>
// </tr>
// </table>

// </div>
// `;

//   return printableContent;
// };

// const pdfFunction = async () => {
//   const printableContent = await buildPrintableContent();
//   if (!printableContent) {
//     console.error("Printable content empty");
//     return;
//   }

//   const container = document.createElement("div");
//   container.id = "pdf-root";
//   container.style.position = "fixed";
//   container.style.left = "0";
//   container.style.top = "0";
//   container.style.width = "210mm";
//   container.style.background = "#fff";
//   container.style.zIndex = "99999";

//   container.innerHTML = printableContent;
//   document.body.appendChild(container);

//   // wait for layout + images
//   await new Promise(r => setTimeout(r, 800));

//   const options = {
//     margin: 10,
//     filename: `Invoice_${watch("entrynumber")}.pdf`,
//     image: { type: "jpeg", quality: 0.98 },
//     html2canvas: {
//       scale: 2,
//       useCORS: true,
//       backgroundColor: "#ffffff",
//       logging: false,
//     },
//     jsPDF: {
//       unit: "mm",
//       format: "a4",
//       orientation: "portrait",
//     },
//   };

//   try {
//     const worker = html2pdf()
//       .set(options)
//       .from(container);

//     // 🔥 IMPORTANT PART
//     await worker.toPdf().get("pdf").then(pdf => {
//       pdf.save(options.filename);
//     });
//   } catch (err) {
//     console.error("PDF generation failed:", err);
//   } finally {
//     document.body.removeChild(container);
//   }
// };




// small helper to escape html text (prevents accidental tags)
function escapeHtml(text) {
  if (text === null || text === undefined) return "";
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}


// const handlePrint = () => {
//   const printA4 = document.getElementById("printA4").checked;
//   const printThermal = document.getElementById("printThermal").checked;

//   if (printA4) {
//     printA4Function(); // Calls the A4 print function
//   } else if (printThermal) {
//     thermalPrintFunction(); // Calls the 3-inch thermal print function
//   } else {
//     alert("Please select a print type.");
//   }
  
// };
const handlePrint = (type) => {
  if (type === "A4") {
    printA4Function(); // Calls the A4 print function
  } else if (type === "Thermal") {
    thermalPrintFunction(); // Calls the 3-inch thermal print function
  } else {
    alert("Invalid selection.");
  }
};

  const barcodeIcon = (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
      <path d="M2 4V2.6h1.6M14 4V2.6h-1.6M2 12v1.4h1.6M14 12v1.4h-1.6" />
      <path d="M5 5v6M7 5v6M9.2 5v6M11.4 5v6" />
    </svg>
  );

  // columns actually rendered in a line, for the detail row's colSpan
  // idx, barcode (hidden), item, unit, qty, rate, gross, disc %, disc amt,
  // amount, actions - then whichever optional columns are on
  const lineColSpan =
    11 +
    (taxOn ? 2 : 0) +
    (optionalCols.mrp ? 1 : 0) +
    (optionalCols.foc ? 1 : 0) +
    (optionalCols.batch ? 1 : 0) +
    (optionalCols.expiry ? 1 : 0);

  const mrpRules = {
    validate: (value) =>
      (!isNaN(value) && value >= 0) || "MRP must be zero or more",
  };
  const focRules = {
    validate: (value) =>
      (!isNaN(value) && value >= 0) || "FOC must be zero or more",
  };

  return (
    <div>
      <div
        className="modal fade show si-term"
        data-si-theme={siTheme}
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <form
              id="invoice-content"
              ref={formRef}
              className="si-form"
              onSubmit={handleSubmit(handleFormSubmit)}
              onKeyDown={onFormKeyDown}
            >
              <div className="si-grid">
                <div className="si-left">
                  {/* ============ COMMAND BAR ============ */}
                  <header className="si-cmd">
                    <button
                      type="button"
                      className="si-back"
                      onClick={handleClose}
                      title="Back to invoice list"
                      aria-label="Back"
                    >
                      <ArrowLeft />
                    </button>
                    <div className="si-doc">
                      <h1>Sales Invoice</h1>
                      <span className="si-doc-no">
                        {watch("entrynumber") || "—"}
                      </span>
                      <span className={`si-state si-state--${docState.key}`}>
                        {docState.label}
                      </span>
                    </div>
                    {/* the print builder reads this input by name */}
                    <input
                      type="text"
                      className="si-offscreen"
                      tabIndex={-1}
                      aria-hidden="true"
                      {...register("entrynumber")}
                      required
                      disabled
                    />
                    <div className="si-spacer" />
                    <div className="si-cmd-actions">
                      {currentUser?.name && (
                        <div className="si-userchip" title="Signed in">
                          <span className="si-av">{userInitials}</span>
                          <span className="si-un">{currentUser.name}</span>
                        </div>
                      )}
                      {currentUser?.name && branch?.name && (
                        <span className="si-sepbar" />
                      )}
                      {branch?.name && (
                        <span className="si-branch" title="Branch">
                          <MapPin />
                          {branch.name}
                        </span>
                      )}
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={toggleTheme}
                        title={
                          siTheme === "dark"
                            ? "Switch to light"
                            : "Switch to dark"
                        }
                        aria-label="Switch light or dark theme"
                      >
                        {siTheme === "dark" ? <Sun /> : <Moon />}
                      </button>
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={toggleFullScreen}
                        title={isFullScreen ? "Exit full screen" : "Full screen"}
                        aria-label="Full screen"
                      >
                        {isFullScreen ? <Minimize /> : <Maximize />}
                      </button>
                    </div>
                  </header>

                  {/* ============ PARTY STRIP ============ */}
                  <section className="si-strip">
                    <div className="si-strip-row">
                      <div className="si-fld si-fld--cust">
                        <label>
                          Customer <span className="si-req">*</span>
                        </label>
                        <div className="si-fld-ctl">
                          <Controller
                            control={control}
                            name={`customer`}
                            render={({ field: { onChange, value, ref } }) => (
                              <Select
                                ref={ref}
                                classNamePrefix="react-select"
                                className="si-sel"
                                options={customerData}
                                placeholder="Name or code — F2"
                                value={customerData?.find(
                                  (customer) => customer?.value === value
                                )}
                                onChange={(selectedOption) => {
                                  onChange(selectedOption.value);
                                  handlecustomerDetailFetch(selectedOption);
                                }}
                                menuPortalTarget={menuPortalTarget}
                                menuPosition="fixed"
                                styles={siSelectStyles}
                                required
                              />
                            )}
                          />
                          <button
                            type="button"
                            className="si-fld-add"
                            title="Add a new customer"
                            aria-label="Add a new customer"
                            onClick={() => setModalOpen(true)}
                          >
                            <Plus />
                          </button>
                        </div>
                      </div>

                      <div className="si-fld">
                        <label>
                          Warehouse <span className="si-req">*</span>
                        </label>
                        <Controller
                          name="location"
                          control={control}
                          render={({ field }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={formattedWarehouses}
                              required
                              placeholder="Select warehouse"
                              value={getSelectedWarehouseOption(field.value)}
                              onChange={(option) =>
                                field.onChange(option.value)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                            />
                          )}
                        />
                      </div>

                      <div className="si-fld">
                        <label>Salesman</label>
                        <Controller
                          control={control}
                          name="salesman"
                          render={({ field: { onChange, value } }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={salesmanOptions}
                              placeholder="Select salesman"
                              isClearable
                              value={
                                salesmanOptions?.find(
                                  (o) => o.value === value
                                ) ?? null
                              }
                              onChange={(opt) =>
                                onChange(opt ? opt.value : null)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                            />
                          )}
                        />
                      </div>

                      <div className="si-fld">
                        <label>
                          Payment <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name={`paymentType`}
                          render={({ field: { onChange, value } }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={paymentType}
                              value={paymentType?.find(
                                (paymentType) => paymentType?.value === value
                              )}
                              onChange={(selectedOption) =>
                                onChange(selectedOption.value)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                              required
                            />
                          )}
                        />
                      </div>

                      <div className="si-fld">
                        <label>
                          Date <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name="invdate"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              value={value ? dayjs(value) : dayjs()}
                              format="DD-MM-YYYY"
                              onChange={(date) => {
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                );
                                setmindate(date);
                              }}
                            />
                          )}
                        />
                      </div>

                      <button
                        type="button"
                        className="si-moretoggle"
                        aria-expanded={moreOpen}
                        onClick={toggleMore}
                      >
                        <span>More</span>
                        <ChevronDown />
                      </button>
                    </div>

                    {/* kept mounted while collapsed: the print builder reads
                        the contact inputs by name */}
                    <div className="si-strip-row si-strip-row--more" hidden={!moreOpen}>
                      <div className="si-fld">
                        <label>
                          Delivery date <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name="deliveryDate"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              minDate={mindate}
                              value={value ? dayjs(value) : dayjs()}
                              format="DD-MM-YYYY"
                              onChange={(date) =>
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                )
                              }
                            />
                          )}
                        />
                        {errors.deliveryDate && (
                          <span className="si-err">
                            {errors.deliveryDate.message}
                          </span>
                        )}
                      </div>
                      <div className="si-fld">
                        <label>
                          Refer type <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name={`referencetype`}
                          render={({ field: { onChange, value } }) => (
                            <Select
                              classNamePrefix="react-select"
                              className="si-sel"
                              options={referencetype}
                              value={referencetype?.find(
                                (reference) => reference?.value === value
                              )}
                              onChange={(selectedOption) =>
                                onChange(selectedOption.value)
                              }
                              menuPortalTarget={menuPortalTarget}
                              menuPosition="fixed"
                              styles={siSelectStyles}
                              required
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Reference no.</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="—"
                          {...register("refNo")}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Contact</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Name at delivery point"
                          {...register("customerName")}
                        />
                        {errors.customerName && (
                          <span className="si-err">
                            {errors.customerName.message}
                          </span>
                        )}
                      </div>
                      <div className="si-fld">
                        <label>Contact no.</label>
                        <input
                          type="text"
                          className="si-in si-in--mono"
                          placeholder="Mobile number"
                          {...register("customerContactno")}
                        />
                        {errors.customerContactno && (
                          <span className="si-err">
                            {errors.customerContactno.message}
                          </span>
                        )}
                      </div>
                      <div className="si-fld">
                        <label>Remarks</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Note printed on the invoice"
                          {...register("terms")}
                        />
                      </div>
                    </div>
                  </section>

                  {/* ============ LINES ============ */}
                  <section className="si-lines">
                    <div className="si-scanbar">
                      <div className="si-scanwrap">
                        {barcodeIcon}
                        <input
                          ref={scanRef}
                          className="si-scan"
                          value={scanText}
                          onChange={onScanChange}
                          onKeyDown={onScanKeyDown}
                          onFocus={() => setScanOpen(true)}
                          onBlur={() => setScanOpen(false)}
                          autoComplete="off"
                          placeholder="Scan barcode or type item name…"
                          aria-label="Scan barcode or search items"
                        />
                        <span className="si-kbd si-scan-kbd">F3</span>
                      </div>

                      {entryFlow !== "direct" && (
                        <div
                          className={`si-entryfld${
                            armed === "qty" ? " si-entryfld--armed" : ""
                          }`}
                        >
                          <label htmlFor="si-entry-qty">Qty</label>
                          <input
                            id="si-entry-qty"
                            ref={qtyRef}
                            inputMode="decimal"
                            autoComplete="off"
                            value={entryQty}
                            onChange={(e) => setEntryQty(e.target.value)}
                            onKeyDown={onEntryQtyKeyDown}
                          />
                        </div>
                      )}

                      {entryFlow === "qtyprice" && (
                        <div
                          className={`si-entryfld si-entryfld--wide${
                            armed === "price" ? " si-entryfld--armed" : ""
                          }`}
                        >
                          <label htmlFor="si-entry-price">Price</label>
                          <input
                            id="si-entry-price"
                            ref={priceRef}
                            inputMode="decimal"
                            autoComplete="off"
                            value={entryPrice}
                            onChange={(e) => setEntryPrice(e.target.value)}
                            onKeyDown={onEntryPriceKeyDown}
                          />
                        </div>
                      )}

                      <button
                        type="button"
                        className="si-iconbtn si-iconbtn--tall"
                        aria-expanded={flowOpen}
                        title="Item entry flow"
                        aria-label="Item entry flow settings"
                        onClick={() => setFlowOpen((o) => !o)}
                      >
                        <Sliders />
                      </button>

                      {scanOpen && scanResults.length > 0 && (
                        <div
                          className="si-results"
                          onMouseDown={(e) => e.preventDefault()}
                        >
                          <div className="si-res-head">
                            <span>Item</span>
                            <span>Unit</span>
                            <span>Rate</span>
                            <span>MRP</span>
                          </div>
                          {scanResults.map((p, i) => (
                            <div
                              key={p.guid + (p.__variant ? `|${p.__variant.variantID}` : "")}
                              className={`si-res${
                                i === scanSel ? " si-res--sel" : ""
                              }`}
                              onMouseEnter={() => setScanSel(i)}
                              onClick={() => beginEntry(p)}
                            >
                              <div className="si-res-item">
                                <div className="nm">{p.name}</div>
                                <div className="cd">
                                  {[p.code, p.barcode]
                                    .filter(Boolean)
                                    .join(" · ")}
                                </div>
                              </div>
                              <div className="si-res-m">
                                {unitLabel(p.unit) || "—"}
                              </div>
                              <div className="si-res-m">
                                <b>{fmtN(p.retailRate)}</b>
                              </div>
                              <div className="si-res-m">
                                {safeNumber(p.mrp) > 0 ? fmtN(p.mrp) : "—"}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      {flowOpen && (
                        <>
                          <div
                            className="si-pop-scrim si-pop-scrim--clear"
                            onClick={() => setFlowOpen(false)}
                          />
                          <div className="si-pop si-flowpop" role="dialog">
                            <div className="si-pop-h">Item entry flow</div>
                            {[
                              {
                                v: "direct",
                                t: "Straight to the grid",
                                h: "Picking an item adds it with quantity 1. Fastest for barcode scanning.",
                              },
                              {
                                v: "qty",
                                t: "Ask quantity, then add",
                                h: "Control moves to Qty. Enter adds the line at the list price.",
                              },
                              {
                                v: "qtyprice",
                                t: "Ask quantity, then price",
                                h: "Qty → Enter → Price → Enter adds the line. Use when rates are negotiated.",
                              },
                            ].map((o) => (
                              <label className="si-opt" key={o.v}>
                                <input
                                  type="radio"
                                  name="si-entry-flow"
                                  checked={entryFlow === o.v}
                                  onChange={() => setEntryFlow(o.v)}
                                />
                                <span>
                                  <b>{o.t}</b>
                                  <i>{o.h}</i>
                                </span>
                              </label>
                            ))}
                          </div>
                        </>
                      )}
                    </div>

                    {lastAdded && (
                      <div className="si-lastline">
                        <span className="si-tag">Last added</span>
                        <b>{lastAdded.name}</b>
                        <span className="si-q">
                          × {lastAdded.qty}
                          {lastAdded.unit ? ` ${lastAdded.unit}` : ""} @{" "}
                          {fmtN(lastAdded.price)}
                        </span>
                      </div>
                    )}

                    <div className="si-cols">
                      <span className="si-lbl">Columns</span>
                      {OPTIONAL_COLS.filter(
                        (c) => c.key !== "tax" || taxOn
                      ).map((col) => (
                        <button
                          key={col.key}
                          type="button"
                          className="si-colchip"
                          aria-pressed={!!optionalCols[col.key]}
                          onClick={() => toggleCol(col.key)}
                        >
                          {col.label}
                        </button>
                      ))}
                      <div className="si-cols-right">
                        <button
                          type="button"
                          className="si-iconbtn"
                          onClick={() => resetmodal()}
                        >
                          <RotateCcw />
                          <span>Reset</span>
                        </button>
                      </div>
                    </div>

                    <div className="si-tablewrap">
                      <table
                        className="si-table"
                        style={{ minWidth: `${tableMinWidth}px` }}
                      >
                        <thead>
                          <tr>
                            <th className="n" style={{ width: colW("idx") }}>
                              #
                            </th>
                            <th className="si-col-off">Barcode</th>
                            <th style={{ width: colW("item") }}>
                              Item <span className="si-req">*</span>
                            </th>
                            <th style={{ width: colW("unit") }}>Unit</th>
                            <th className="n" style={{ width: colW("qty") }}>
                              Qty <span className="si-req">*</span>
                            </th>
                            <th className="n" style={{ width: colW("rate") }}>
                              Rate <span className="si-req">*</span>
                            </th>
                            <th
                              className={`n ${hideClass("gross")}`}
                              style={{ width: colW("gross") }}
                            >
                              Gross
                            </th>
                            <th className="n" style={{ width: colW("discPct") }}>
                              Disc %
                            </th>
                            <th className="n" style={{ width: colW("discAmt") }}>
                              Disc Amt
                            </th>
                            {taxOn && (
                              <th
                                className={`n ${hideClass("tax")}`}
                                style={{ width: colW("taxPct") }}
                              >
                                VAT %
                              </th>
                            )}
                            {taxOn && (
                              <th
                                className={`n ${hideClass("tax")}`}
                                style={{ width: colW("taxAmt") }}
                              >
                                VAT Amt
                              </th>
                            )}
                            {optionalCols.mrp && (
                              <th className="n" style={{ width: colW("mrp") }}>
                                MRP
                              </th>
                            )}
                            {optionalCols.foc && (
                              <th className="n" style={{ width: colW("foc") }}>
                                FOC
                              </th>
                            )}
                            {optionalCols.batch && (
                              <th style={{ width: colW("batch") }}>Batch</th>
                            )}
                            {optionalCols.expiry && (
                              <th style={{ width: colW("expiry") }}>Expiry</th>
                            )}
                            <th className="n" style={{ width: colW("amount") }}>
                              Amount
                            </th>
                            <th style={{ width: colW("act") }} aria-label="Line actions" />
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field, index) => {
                            const rowProduct = productByGuid(
                              watch(`items[${index}].product`)
                            );
                            const rowCode = [
                              rowProduct?.code,
                              rowProduct?.barcode,
                            ]
                              .filter(Boolean)
                              .join(" · ");
                            const open = !!openRows[field.id];
                            const hasNote = !!watch(`items[${index}].notes`);
                            const rowPrice = safeNumber(
                              watch(`items[${index}].price`)
                            );
                            const rowCost = safeNumber(rowProduct?.cost);
                            const rowMargin =
                              rowCost > 0 && rowPrice > 0
                                ? ((rowPrice - rowCost) / rowPrice) * 100
                                : null;
                            return (
                              <React.Fragment key={field.id}>
                                <tr className="si-line" data-line={index}>
                                  <td className="si-idx">{index + 1}</td>
                                  {/* never shown - the print builder reads the
                                      code from this cell */}
                                  <td data-label="Barcode" className="si-col-off">
                                    <input
                                      type="text"
                                      tabIndex={-1}
                                      {...register(`items[${index}].code`)}
                                    />
                                  </td>
                                  <td data-label="Description">
                                    <div className="si-itemcell">
                                      <button
                                        type="button"
                                        className="si-exp"
                                        aria-expanded={open}
                                        aria-label="Line details"
                                        onClick={() => toggleRow(field.id)}
                                      >
                                        <ChevronRight />
                                      </button>
                                      <div className="si-item-txt">
                                        <Controller
                                          control={control}
                                          name={`items[${index}].product`}
                                          rules={{
                                            validate: (value) => {
                                              if (isPlaceholderRow(index))
                                                return true;
                                              if (!value)
                                                return "Product is required";
                                              const isDuplicate = isDuplicateLine(watch("items"), index);
                                              return (
                                                !isDuplicate ||
                                                "Duplicate product selected!"
                                              );
                                            },
                                          }}
                                          render={({
                                            field: { onChange, value },
                                          }) => (
                                            <Select
                                              classNamePrefix="react-select"
                                              className="si-itemsel"
                                              options={products}
                                              filterOption={productFilterOption}
                                              placeholder="Item name or barcode"
                                              value={products?.find(
                                                (option) => option.value === value
                                              )}
                                              onChange={(selectedOption) => {
                                                onChange(selectedOption.value);
                                                handleEachProductfetch(
                                                  selectedOption,
                                                  index
                                                );
                                              }}
                                              menuPortalTarget={menuPortalTarget}
                                              menuPosition="fixed"
                                              styles={siSelectStyles}
                                            />
                                          )}
                                        />
                                        {/* drawn with ::after so it stays out of
                                            the cell's innerText, which the A4
                                            print uses as the description */}
                                        {rowCode && (
                                          <div
                                            className="si-item-cd"
                                            data-cd={withVariant(rowCode, watch(`items[${index}].variantLabel`))}
                                            aria-hidden="true"
                                          />
                                        )}
                                      </div>
                                    </div>
                                    {errors.items &&
                                      errors.items[index]?.product && (
                                        <span className="si-err">
                                          {errors.items[index].product.message}
                                        </span>
                                      )}
                                  </td>
                                  <td data-label="Unit">
                                    <Controller
                                      control={control}
                                      name={`items[${index}].unit`}
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <Select
                                          classNamePrefix="react-select"
                                          className="si-unitsel"
                                          options={unitData}
                                          value={unitData?.find(
                                            (option) => option.value === value
                                          )}
                                          onChange={(selectedOption) => {
                                            // unitData options carry the unit
                                            // GUID, which is what the payload
                                            // and the edit loader both expect
                                            onChange(selectedOption.value);
                                          }}
                                          menuPortalTarget={menuPortalTarget}
                                          menuPosition="fixed"
                                          styles={siSelectStyles}
                                          placeholder="—"
                                        />
                                      )}
                                    />
                                  </td>
                                  <td data-label="Quantity" className="n">
                                    <input
                                      type="text"
                                      inputMode="decimal"
                                      className="si-cellin"
                                      {...register(`items[${index}].quantity`, {
                                        validate: (value) => {
                                          if (isPlaceholderRow(index))
                                            return true;
                                          if (value === "" || value == null)
                                            return "Quantity is required";
                                          return (
                                            (!isNaN(value) && value > 0) ||
                                            "Quantity must be a positive number"
                                          );
                                        },
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.quantity && (
                                        <span className="si-err">
                                          {errors.items[index].quantity.message}
                                        </span>
                                      )}
                                  </td>
                                  <td data-label="Price" className="n">
                                    <input
                                      type="text"
                                      inputMode="decimal"
                                      className="si-cellin"
                                      {...register(`items[${index}].price`, {
                                        validate: (value) => {
                                          if (isPlaceholderRow(index))
                                            return true;
                                          if (value === "" || value == null)
                                            return "Price is required";
                                          return (
                                            (!isNaN(value) && value > 0) ||
                                            "Price must be a positive number"
                                          );
                                        },
                                      })}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.price && (
                                        <span className="si-err">
                                          {errors.items[index].price.message}
                                        </span>
                                      )}
                                  </td>
                                  {/* stays mounted when hidden - print reads it */}
                                  <td
                                    data-label="Gross"
                                    className={`n ${hideClass("gross")}`}
                                  >
                                    <input
                                      type="text"
                                      className="si-cellin si-cellin--ro"
                                      tabIndex={-1}
                                      {...register(`items[${index}].gross`)}
                                      disabled
                                    />
                                  </td>
                                  <td data-label="Discount Percentage" className="n">
                                    <input
                                      type="text"
                                      inputMode="decimal"
                                      className="si-cellin"
                                      {...register(
                                        `items[${index}].discountPercentage`,
                                        {
                                          ...discPctEvents(setValue, index),
                                          validate: (value) =>
                                            value === "" ||
                                            value === null ||
                                            value === undefined ||
                                            (!isNaN(value) &&
                                              Number(value) >= 0 &&
                                              Number(value) <= 100) ||
                                            "Discount % must be between 0 and 100",
                                        }
                                      )}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.discountPercentage && (
                                        <span className="si-err">
                                          {
                                            errors.items[index]
                                              .discountPercentage.message
                                          }
                                        </span>
                                      )}
                                  </td>
                                  <td data-label="Discount Amount" className="n">
                                    <input
                                      type="text"
                                      inputMode="decimal"
                                      className="si-cellin"
                                      {...register(
                                        `items[${index}].discountAmount`,
                                        discAmtRules(setValue, getValues, index)
                                      )}
                                    />
                                    {errors.items &&
                                      errors.items[index]?.discountAmount && (
                                        <span className="si-err">
                                          {
                                            errors.items[index].discountAmount
                                              .message
                                          }
                                        </span>
                                      )}
                                  </td>
                                  {taxOn && (
                                    <td
                                      data-label="Tax %"
                                      className={`n ${hideClass("tax")}`}
                                    >
                                      <Controller
                                        control={control}
                                        name={`items[${index}].taxPercentage`}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <Select
                                            classNamePrefix="react-select"
                                            className="si-taxsel"
                                            options={taxData}
                                            placeholder="—"
                                            value={taxData?.find(
                                              (option) => option.guid === value
                                            )}
                                            onChange={(selectedOption) => {
                                              // this field holds the tax GUID -
                                              // the row calculation, the submit
                                              // payload and the edit loader all
                                              // resolve it with .guid
                                              onChange(
                                                selectedOption
                                                  ? selectedOption.guid
                                                  : null
                                              );
                                            }}
                                            menuPortalTarget={menuPortalTarget}
                                            menuPosition="fixed"
                                            styles={siSelectStyles}
                                          />
                                        )}
                                      />
                                    </td>
                                  )}
                                  {taxOn && (
                                    <td
                                      data-label="Tax Amount"
                                      className={`n ${hideClass("tax")}`}
                                    >
                                      <input
                                        type="text"
                                        className="si-cellin si-cellin--ro"
                                        tabIndex={-1}
                                        {...register(
                                          `items[${index}].taxAmount`
                                        )}
                                        disabled
                                      />
                                    </td>
                                  )}
                                  {optionalCols.mrp && (
                                    <td className="n">
                                      <input
                                        type="text"
                                        inputMode="decimal"
                                        className="si-cellin"
                                        {...register(
                                          `items[${index}].mrp`,
                                          mrpRules
                                        )}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.mrp && (
                                          <span className="si-err">
                                            {errors.items[index].mrp.message}
                                          </span>
                                        )}
                                    </td>
                                  )}
                                  {optionalCols.foc && (
                                    <td className="n">
                                      <input
                                        type="text"
                                        inputMode="decimal"
                                        className="si-cellin"
                                        {...register(
                                          `items[${index}].foc`,
                                          focRules
                                        )}
                                      />
                                      {errors.items &&
                                        errors.items[index]?.foc && (
                                          <span className="si-err">
                                            {errors.items[index].foc.message}
                                          </span>
                                        )}
                                    </td>
                                  )}
                                  {optionalCols.batch && (
                                    <td>
                                      <input
                                        type="text"
                                        className="si-cellin si-cellin--text"
                                        {...register(`items[${index}].batch`)}
                                      />
                                    </td>
                                  )}
                                  {optionalCols.expiry && (
                                    <td>
                                      <Controller
                                        control={control}
                                        name={`items[${index}].expiry`}
                                        render={({
                                          field: { onChange, value },
                                        }) => (
                                          <DatePicker
                                            className="si-celldate"
                                            value={
                                              value ? dayjs(value) : dayjs()
                                            }
                                            format="DD-MM-YY"
                                            allowClear={false}
                                            onChange={(date) => onChange(date)}
                                          />
                                        )}
                                      />
                                    </td>
                                  )}
                                  <td data-label="Net Amount" className="n si-amt">
                                    <input
                                      type="text"
                                      className="si-cellin si-cellin--amt"
                                      tabIndex={-1}
                                      {...register(`items[${index}].netTotal`)}
                                      disabled
                                    />
                                  </td>
                                  <td>
                                    <div className="si-rowacts">
                                      <button
                                        type="button"
                                        className={`si-rowbtn${
                                          hasNote ? " si-rowbtn--has" : ""
                                        }`}
                                        title={
                                          hasNote
                                            ? watch(`items[${index}].notes`)
                                            : "Add a note to this line"
                                        }
                                        aria-label="Line note"
                                        onClick={() => toggleRow(field.id, true)}
                                      >
                                        <FileText />
                                      </button>
                                      <button
                                        type="button"
                                        className="si-rowbtn si-rowbtn--del"
                                        title="Remove line (Ctrl+Del)"
                                        aria-label="Remove line"
                                        onClick={() => handleRemove(index)}
                                      >
                                        <Trash2 />
                                      </button>
                                    </div>
                                  </td>
                                </tr>

                                {open && (
                                  <tr className="si-subrow">
                                    <td colSpan={lineColSpan}>
                                      <div className="si-subgrid">
                                        {!optionalCols.batch && (
                                          <div className="si-subfld">
                                            <label>Batch</label>
                                            <input
                                              type="text"
                                              {...register(
                                                `items[${index}].batch`
                                              )}
                                            />
                                          </div>
                                        )}
                                        {!optionalCols.expiry && (
                                          <div className="si-subfld">
                                            <label>Expiry</label>
                                            <Controller
                                              control={control}
                                              name={`items[${index}].expiry`}
                                              render={({
                                                field: { onChange, value },
                                              }) => (
                                                <DatePicker
                                                  className="si-celldate"
                                                  value={
                                                    value
                                                      ? dayjs(value)
                                                      : dayjs()
                                                  }
                                                  format="DD-MM-YY"
                                                  allowClear={false}
                                                  onChange={(date) =>
                                                    onChange(date)
                                                  }
                                                />
                                              )}
                                            />
                                          </div>
                                        )}
                                        {!optionalCols.mrp && (
                                          <div className="si-subfld">
                                            <label>MRP</label>
                                            <input
                                              type="text"
                                              inputMode="decimal"
                                              {...register(
                                                `items[${index}].mrp`,
                                                mrpRules
                                              )}
                                            />
                                          </div>
                                        )}
                                        {!optionalCols.foc && (
                                          <div className="si-subfld">
                                            <label>FOC qty</label>
                                            <input
                                              type="text"
                                              inputMode="decimal"
                                              {...register(
                                                `items[${index}].foc`,
                                                focRules
                                              )}
                                            />
                                          </div>
                                        )}
                                        <div className="si-subfld si-subfld--grow">
                                          <label>Line note</label>
                                          <input
                                            type="text"
                                            id={`si-note-${field.id}`}
                                            placeholder="e.g. short supply, balance next trip"
                                            {...register(
                                              `items[${index}].notes`
                                            )}
                                          />
                                        </div>
                                      </div>
                                      {rowProduct && (
                                        <div className="si-facts">
                                          {rowProduct.code && (
                                            <div className="si-fact">
                                              <div className="k">Item code</div>
                                              <div className="v">
                                                {rowProduct.code}
                                              </div>
                                            </div>
                                          )}
                                          {rowProduct.barcode && (
                                            <div className="si-fact">
                                              <div className="k">Barcode</div>
                                              <div className="v">
                                                {rowProduct.barcode}
                                              </div>
                                            </div>
                                          )}
                                          <div className="si-fact">
                                            <div className="k">List rate</div>
                                            <div className="v">
                                              {fmtN(rowProduct.retailRate)}
                                            </div>
                                          </div>
                                          {rowCost > 0 && (
                                            <div className="si-fact">
                                              <div className="k">Cost</div>
                                              <div className="v">
                                                {fmtN(rowCost)}
                                              </div>
                                            </div>
                                          )}
                                          {rowMargin !== null && (
                                            <div
                                              className={`si-fact ${
                                                rowMargin < 8
                                                  ? "si-fact--warn"
                                                  : "si-fact--good"
                                              }`}
                                            >
                                              <div className="k">Margin</div>
                                              <div className="v">
                                                {rowMargin.toFixed(1)}%
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                      {rowProduct && (
                                        <SalesLastRates
                                          branch={branch}
                                          customerId={watch("customer")}
                                          productId={rowProduct.guid}
                                          excludeId={data?.guid}
                                          decimals={
                                            Number(decimalpoints) >= 0
                                              ? Number(decimalpoints)
                                              : 2
                                          }
                                        />
                                      )}
                                    </td>
                                  </tr>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                      {lineCount === 0 && (
                        <div className="si-empty">
                          <p className="big">No lines yet</p>
                          <p>
                            Scan a barcode, or press <span className="si-kbd">F3</span>{" "}
                            and type an item name.
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="si-lines-foot">
                      <span>
                        Lines <b>{lineCount}</b>
                      </span>
                      <span>
                        Qty <b>{qtyTotal}</b>
                      </span>
                      <span>
                        Gross <b>{fmtN(totalGross)}</b>
                      </span>
                      {hasCost && (
                        <div className="si-foot-right">
                          <span>
                            Cost <b>{fmtN(costTotal)}</b>
                          </span>
                          {marginPct !== null && (
                            <span>
                              Margin <b>{marginPct.toFixed(1)}%</b>
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </section>

                  {/* ============ PRINT SETUP ============ */}
                  {printPop && (
                    <>
                      <div
                        className="si-pop-scrim si-pop-scrim--clear"
                        onClick={() => setPrintPop(null)}
                      />
                      <div className="si-pop si-printpop" role="dialog">
                        <div className="si-pop-h">
                          {printPop === "confirm"
                            ? "Choose a format to print"
                            : "Print setup"}
                        </div>

                        <div className="si-fmtrow">
                          {PRINT_FORMATS.map((f) => (
                            <button
                              key={f.key}
                              type="button"
                              className="si-fmt"
                              aria-pressed={printPrefs.format === f.key}
                              onClick={() =>
                                setPrintPrefs((prev) => ({
                                  ...prev,
                                  format: f.key,
                                }))
                              }
                            >
                              <b>{f.label}</b>
                              <span>{f.size}</span>
                            </button>
                          ))}
                        </div>

                        {PRINT_FORMATS.map((f) => (
                          <div className="si-prow" key={f.key}>
                            <label htmlFor={`si-prn-${f.key}`}>
                              {f.label} printer
                            </label>
                            <input
                              id={`si-prn-${f.key}`}
                              type="text"
                              placeholder="System default"
                              value={printPrefs.printers[f.key] || ""}
                              onChange={(e) =>
                                setPrintPrefs((prev) => ({
                                  ...prev,
                                  printers: {
                                    ...prev.printers,
                                    [f.key]: e.target.value,
                                  },
                                }))
                              }
                            />
                          </div>
                        ))}

                        <label className="si-remember">
                          <input
                            type="checkbox"
                            checked={!!printPrefs.remember}
                            onChange={(e) =>
                              setPrintPrefs((prev) => ({
                                ...prev,
                                remember: e.target.checked,
                              }))
                            }
                          />
                          <span>
                            Use this format every time — don&apos;t ask again
                          </span>
                        </label>

                        <p className="si-pop-note">
                          Saved for this billing system only. Browsers can&apos;t
                          choose a printer themselves, so the name is a label
                          for the operator - the print dialog still picks the
                          device.
                        </p>

                        <div className="si-popfoot">
                          {printPop === "confirm" ? (
                            <>
                              <button
                                type="button"
                                className="si-primary"
                                onClick={() => {
                                  setPrintPop(null);
                                  submitInvoice(true);
                                }}
                              >
                                Save &amp; print
                              </button>
                              <button
                                type="button"
                                onClick={() => setPrintPop(null)}
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                type="button"
                                className="si-primary"
                                onClick={savePrintDefault}
                              >
                                Save as default
                              </button>
                              <button
                                type="button"
                                onClick={() => setPrintPop(null)}
                              >
                                Close
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  {/* ============ STATUS BAR ============ */}
                  <footer className="si-status">
                    <button
                      type="button"
                      className="si-statbtn"
                      aria-expanded={printPop === "setup"}
                      onClick={() =>
                        setPrintPop((p) => (p ? null : "setup"))
                      }
                    >
                      <Printer />
                      <span>Print setup</span>
                    </button>
                    <span className="si-sepbar" />
                    <span className="si-grp">
                      <span className="si-kbd">F2</span>Customer
                    </span>
                    <span className="si-grp">
                      <span className="si-kbd">F3</span>Item search
                    </span>
                    <span className="si-grp">
                      <span className="si-kbd">F4</span>Tender
                    </span>
                    <span className="si-grp">
                      <span className="si-kbd">F9</span>Save &amp; print
                    </span>
                    <span className="si-grp">
                      <span className="si-kbd">Enter</span>Next line
                    </span>
                    <span className="si-grp">
                      <span className="si-kbd">Ctrl</span>
                      <span className="si-kbd">Del</span>Remove line
                    </span>
                    <span className="si-sp" />
                    <span className="si-grp si-grp--ctx">
                      {[warehouseName, salesmanName, printTarget]
                        .filter(Boolean)
                        .join(" · ")}
                    </span>
                  </footer>
                </div>

                {/* ============ RAIL ============ */}
                <aside className="si-rail">
                  <div className="si-rail-scroll">
                    <div className="si-card">
                      <div className="si-card-h">
                        <span>Account</span>
                        <span className="r">{paymentLabel}</span>
                      </div>
                      <div className="si-party">
                        <div className="nm">
                          {selectedCustomer?.name ||
                            watch("customerName") ||
                            "No customer selected"}
                        </div>
                        <div className="meta">
                          {selectedCustomer
                            ? [
                                selectedCustomer.code,
                                watch("customerContactno") ||
                                  selectedCustomer.mobile,
                              ]
                                .filter((v) => v && `${v}` !== "0")
                                .join(" · ") || "No contact on file"
                            : "Pick a customer — F2"}
                        </div>
                      </div>
                    </div>

                    <div className="si-card">
                      <div className="si-card-h">Invoice total</div>
                      <div className="si-tot">
                        <div className="si-tr">
                          <span className="l">Gross</span>
                          <span className="v">{fmtN(totalGross)}</span>
                        </div>
                        <div className="si-tr">
                          <span className="l">Line discount</span>
                          <span className="v">
                            {lineDiscount > 0
                              ? `−${fmtN(lineDiscount)}`
                              : fmtN(0)}
                          </span>
                        </div>
                        <div className="si-tr si-tr--edit">
                          <span className="l">Bill discount</span>
                          <span className="v">
                            <input
                              type="number"
                              step="any"
                              min={0}
                              inputMode="decimal"
                              defaultValue={0}
                              {...register(`subtraction`, {
                                validate: (value) => {
                                  const discount = safeNumber(value);
                                  const totalNetAfterDiscount =
                                    totalNet - discount;
                                  if (discount < 0) {
                                    return "Discount value should not be negative.";
                                  } else if (totalNetAfterDiscount < 0) {
                                    return "Please enter a discount value that does not exceed the Net Total.";
                                  }
                                  return true;
                                },
                              })}
                            />
                          </span>
                        </div>
                        {errors.subtraction && (
                          <div className="si-tr-err">
                            {errors.subtraction.message}
                          </div>
                        )}
                        <div className="si-tr si-tr--edit">
                          <span className="l">Addition</span>
                          <span className="v">
                            <input
                              type="number"
                              step="any"
                              min={0}
                              inputMode="decimal"
                              defaultValue={0}
                              {...register(`addition`)}
                            />
                          </span>
                        </div>
                        {errors.addition && (
                          <div className="si-tr-err">
                            {errors.addition.message}
                          </div>
                        )}
                        <div className="si-rule" />
                        <div className="si-tr">
                          <span className="l">Taxable</span>
                          <span className="v">{fmtN(taxableTotal)}</span>
                        </div>
                        {taxOn && (
                          <div className="si-tr">
                            <span className="l">VAT</span>
                            <span className="v">{fmtN(totalTax)}</span>
                          </div>
                        )}
                        <TermRoundOff
                          screenKey="salesInvoice"
                          register={register}
                          setValue={setValue}
                          control={control}
                          netTotal={totalNet}
                          decimalpoints={decimalpoints}
                          error={errors.round?.message}
                          rules={{
                            validate: (value) => {
                              const round = safeNumber(value);
                              const totalNetAfterRound = totalNet - round;
                              return (
                                totalNetAfterRound >= 0 ||
                                "Please enter a round-off value that does not exceed Net Total."
                              );
                            },
                          }}
                        />
                      </div>
                      <div className="si-net">
                        <span className="l">Net payable</span>
                        <span className="v" title={fmtN(totalNet)}>
                          {fmtN(totalNet)}
                        </span>
                      </div>
                    </div>

                    <TermTender
                      tender={tender}
                      register={register}
                      setValue={setValue}
                      control={control}
                      Controller={Controller}
                      fmt={fmtN}
                      decimalpoints={decimalpoints}
                      paymentLabel={paymentLabel}
                      error={errors.paid?.message}
                      menuPortalTarget={menuPortalTarget}
                      selectStyles={siSelectStyles}
                    />

                    {/* signed Paid - Net, posted as `change` */}
                    <input
                      type="text"
                      className="si-offscreen"
                      tabIndex={-1}
                      aria-hidden="true"
                      {...register("change")}
                      defaultValue={0}
                      disabled
                    />
                  </div>

                  <div className="si-actions">
                    <button
                      type="submit"
                      className="si-btn si-btn--primary"
                      onClick={(e) => {
                        if (!printPrefs.remember) {
                          e.preventDefault();
                          setPrintPop("confirm");
                          return;
                        }
                        printOnSaveRef.current = true;
                      }}
                    >
                      <Printer />
                      <span>Save &amp; print</span>
                      <span className="si-kbd">F9</span>
                    </button>
                    <div className="si-btn-row">
                      <button
                        type="submit"
                        className="si-btn si-btn--ghost"
                        onClick={() => {
                          printOnSaveRef.current = false;
                        }}
                      >
                        <Check />
                        <span>Save only</span>
                      </button>
                      <button
                        type="button"
                        className="si-btn si-btn--ghost"
                        onClick={pdfFunction}
                      >
                        <FileText />
                        <span>PDF</span>
                      </button>
                    </div>
                  </div>
                </aside>
              </div>
            </form>
          </div>
        </div>
        {/* react-select menus portal here so they inherit the .si-term tokens */}
        <div ref={setMenuHost} className="si-menu-host" />
      </div>

      {modalOpen && (
        <CustomerModal
          mode="add"
          data={{}}
          handleClose={() => setModalOpen(false)}
          handleRefresh={() => {}}
        />
      )}
    </div>
  );
};
export default SalesInvoiceModal;
